<template>
  <div>
    <!-- 全局加载页面 -->
    <div v-if="isPageLoading" class="page-loading-overlay">
      <div class="page-loading-content">
        <div class="page-loading-spinner"></div>
        <p class="page-loading-text">页面加载中...</p>
      </div>
    </div>

    <!-- 进入车队加载效果 -->
    <div v-if="isJoiningCar" class="page-loading-overlay">
      <div class="page-loading-content">
        <div class="page-loading-spinner"></div>
        <p class="page-loading-text">进入车队中...</p>
      </div>
    </div>

    <input id="nav-toggle" type="checkbox" />
    <div v-if="!isPageLoading" class="page">
      <aside class="sidebar">
        <label for="nav-toggle" class="close-btn">×</label>
        <div class="side-box">
          <div v-if="config.siteName || config.siteLogo" class="side-brand">
            <img v-if="config.siteLogo" :src="config.siteLogo" alt="Logo" style="width:24px;height:24px;border-radius:6px;object-fit:cover" />
            <strong v-if="config.siteName">{{ config.siteName }}</strong>
          </div>
        </div>
        <div class="side-box">
          <nav class="nav">
            <div 
              v-if="config.chatgptMenuName"
              class="nav-item" 
              :class="{ active: currentCategory === 'chatgpt' && !iframeMode && !showProfile && !showMdConvert && !showCodex }" 
              @click="switchCategory('chatgpt')"
            >
              {{ config.chatgptMenuName }}
            </div>
            <div 
              v-if="config.grokMenuName"
              class="nav-item" 
              :class="{ active: currentCategory === 'grok' && !iframeMode && !showProfile && !showMdConvert && !showCodex }" 
              @click="switchCategory('grok')"
            >
              {{ config.grokMenuName }}
            </div>
            <div 
              v-if="config.geminiMenuName"
              class="nav-item" 
              :class="{ active: currentCategory === 'gemini' && !iframeMode && !showProfile && !showMdConvert && !showCodex }" 
              @click="switchCategory('gemini')"
            >
              {{ config.geminiMenuName }}
            </div>
            <!-- GPT Codex 菜单 -->
            <div 
              v-if="config.isAuthCodex"
              class="nav-item" 
              :class="{ active: showCodex }"
              @click="openCodex"
            >
              GPT Codex
            </div>
            <!-- AI 绘图站 -->
            <div
              v-if="drawingUrl"
              class="nav-item"
              @click="goToDrawing"
            >
              AI绘图站
            </div>
            <div 
              v-for="menu in customMenus" 
              :key="menu.id" 
              class="nav-item" 
              :class="{ active: iframeMode && currentMenuId === menu.id && !showProfile && !showMdConvert && !showCodex }"
              @click="openInIframe(menu.url, menu.name, menu.id)"
            >
              {{ menu.name }}
            </div>
            <!-- MD转换菜单 -->
            <div 
              class="nav-item" 
              :class="{ active: showMdConvert }"
              @click="openMdConvert"
            >
              MD转换
            </div>
            <div 
              v-if="isLoggedIn"
              class="nav-item" 
              :class="{ active: showProfile }"
              @click="openProfile"
            >
              个人中心
            </div>
          </nav>
        </div>
      </aside>

      <label class="drawer-mask" for="nav-toggle"></label>

      <main class="main">
        <div class="page-header">
          <div class="sys">
            <label class="hamburger" for="nav-toggle">☰</label>
            <div class="brand">
              <img v-if="config.siteLogo" :src="config.siteLogo" alt="Logo" style="width:22px;height:22px;border-radius:6px;object-fit:cover" />
              <strong>{{ config.siteName || 'ShareAI' }}</strong>
            </div>
          </div>
          <div class="redeem">
            <!-- 登录用户：显示兑换码按钮、新PLUS站按钮和用户信息 -->
            <template v-if="isLoggedIn">
              <div class="action-buttons">
                <span v-if="config.exchangeName" class="btn-redeem" @click="openExchangeModal">{{ config.exchangeName }}</span>
                <span class="btn-plus" @click="openNewPlusSiteModal">点我前往新PLUS站点</span>
              </div>
              <div class="userpill">
                <div>{{ userInfo.userToken || userInfo.email }}</div>
                <small>{{ headerExpireLabel }} 有效期 {{ formatExpireTime(headerExpireTime) }}</small>
              </div>
            </template>
            
            <!-- 游客：只显示登录按钮 -->
            <template v-else>
              <span class="btn-login" @click="goToLogin">登录</span>
            </template>
          </div>
        </div>

        <div v-if="carNotice && !iframeMode && !showProfile && !showMdConvert && !showCodex" class="notice box">
          <iframe
            :srcdoc="noticeHtml"
            sandbox="allow-same-origin"
            scrolling="no"
            class="notice-iframe"
            @load="resizeNoticeIframe"
            ref="noticeIframeRef"
          ></iframe>
        </div>

        <div v-if="!iframeMode && !showProfile && !showMdConvert && !showCodex" class="fleet-toolbar box">
          <div class="quick-nav">
            <button 
              class="quick-nav-btn" 
              :class="{ active: currentCategory === 'chatgpt' }" 
              @click="switchCategory('chatgpt')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="18" height="18">
                <path d="M 14.070312 2 C 11.330615 2 8.9844456 3.7162572 8.0390625 6.1269531 C 6.061324 6.3911222 4.2941948 7.5446684 3.2773438 9.3066406 C 1.9078196 11.678948 2.2198602 14.567816 3.8339844 16.591797 C 3.0745422 18.436097 3.1891418 20.543674 4.2050781 22.304688 C 5.5751778 24.677992 8.2359331 25.852135 10.796875 25.464844 C 12.014412 27.045167 13.895916 28 15.929688 28 C 18.669385 28 21.015554 26.283743 21.960938 23.873047 C 23.938676 23.608878 25.705805 22.455332 26.722656 20.693359 C 28.09218 18.321052 27.78014 15.432184 26.166016 13.408203 C 26.925458 11.563903 26.810858 9.4563257 25.794922 7.6953125 C 24.424822 5.3220082 21.764067 4.1478652 19.203125 4.5351562 C 17.985588 2.9548328 16.104084 2 14.070312 2 z M 14.070312 4 C 15.226446 4 16.310639 4.4546405 17.130859 5.2265625 C 17.068225 5.2600447 17.003357 5.2865019 16.941406 5.3222656 L 12.501953 7.8867188 C 12.039953 8.1527187 11.753953 8.6456875 11.751953 9.1796875 L 11.724609 15.146484 L 9.5898438 13.900391 L 9.5898438 8.4804688 C 9.5898438 6.0104687 11.600312 4 14.070312 4 z M 20.492188 6.4667969 C 21.927441 6.5689063 23.290625 7.3584375 24.0625 8.6953125 C 24.640485 9.696213 24.789458 10.862812 24.53125 11.958984 C 24.470201 11.920997 24.414287 11.878008 24.351562 11.841797 L 19.910156 9.2773438 C 19.448156 9.0113437 18.879016 9.0103906 18.416016 9.2753906 L 13.236328 12.236328 L 13.248047 9.765625 L 17.941406 7.0546875 C 18.743531 6.5915625 19.631035 6.4055313 20.492188 6.4667969 z M 7.5996094 8.2675781 C 7.5972783 8.3387539 7.5898438 8.4087418 7.5898438 8.4804688 L 7.5898438 13.607422 C 7.5898438 14.141422 7.8729844 14.635297 8.3339844 14.904297 L 13.488281 17.910156 L 11.34375 19.134766 L 6.6484375 16.425781 C 4.5094375 15.190781 3.7747656 12.443687 5.0097656 10.304688 C 5.5874162 9.3043657 6.522013 8.5923015 7.5996094 8.2675781 z M 18.65625 10.865234 L 23.351562 13.574219 C 25.490562 14.809219 26.225234 17.556313 24.990234 19.695312 C 24.412584 20.695634 23.477987 21.407698 22.400391 21.732422 C 22.402722 21.661246 22.410156 21.591258 22.410156 21.519531 L 22.410156 16.392578 C 22.410156 15.858578 22.127016 15.364703 21.666016 15.095703 L 16.511719 12.089844 L 18.65625 10.865234 z M 15.009766 12.947266 L 16.78125 13.980469 L 16.771484 16.035156 L 14.990234 17.052734 L 13.21875 16.017578 L 13.228516 13.964844 L 15.009766 12.947266 z M 18.275391 14.853516 L 20.410156 16.099609 L 20.410156 21.519531 C 20.410156 23.989531 18.399687 26 15.929688 26 C 14.773554 26 13.689361 25.54536 12.869141 24.773438 C 12.931775 24.739955 12.996643 24.713498 13.058594 24.677734 L 17.498047 22.113281 C 17.960047 21.847281 18.246047 21.354312 18.248047 20.820312 L 18.275391 14.853516 z M 16.763672 17.763672 L 16.751953 20.234375 L 12.058594 22.945312 C 9.9195938 24.180312 7.1725 23.443687 5.9375 21.304688 C 5.3595152 20.303787 5.2105423 19.137188 5.46875 18.041016 C 5.5297994 18.079003 5.5857129 18.121992 5.6484375 18.158203 L 10.089844 20.722656 C 10.551844 20.988656 11.120984 20.989609 11.583984 20.724609 L 16.763672 17.763672 z" fill="currentColor"/>
              </svg>
              GPT
            </button>
            <button 
              class="quick-nav-btn" 
              :class="{ active: currentCategory === 'grok' }" 
              @click="switchCategory('grok')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="18" height="18">
                <path d="M 47.658203 2.0566406 C 47.415078 2.0662656 47.174734 2.1631563 46.990234 2.3476562 L 40.880859 8.4648438 C 40.833859 8.4968438 40.789047 8.5351719 40.748047 8.5761719 L 19.146484 30.304688 C 18.777484 30.675688 18.755656 31.266109 19.097656 31.662109 C 19.440656 32.058109 20.027219 32.1245 20.449219 31.8125 L 35.529297 20.667969 C 35.657297 20.572969 35.818125 20.540172 35.953125 20.576172 C 36.101125 20.617172 36.145156 20.725719 36.160156 20.761719 C 37.941156 25.057719 36.981844 29.949656 33.714844 33.222656 C 30.821844 36.118656 26.849547 37.186391 22.810547 36.150391 C 22.575547 36.090391 22.321516 36.119422 22.103516 36.232422 L 16.794922 38.984375 C 16.467922 39.153375 16.259906 39.489422 16.253906 39.857422 C 16.247906 40.225422 16.445625 40.566094 16.765625 40.746094 C 19.618625 42.341094 22.706953 43.119141 25.751953 43.119141 C 30.372953 43.119141 34.89475 41.326094 38.34375 37.871094 C 42.74375 33.467094 44.536297 27.227297 43.154297 21.154297 C 43.150297 21.114297 43.142812 21.073203 43.132812 21.033203 C 41.376812 13.469203 43.505828 10.537469 48.173828 4.1054688 L 48.507812 3.640625 C 48.813813 3.217625 48.741703 2.6309688 48.345703 2.2929688 C 48.147703 2.1249687 47.901328 2.0470156 47.658203 2.0566406 z M 25.996094 7.1367188 C 21.206724 7.0397839 16.477547 8.8765469 12.935547 12.419922 C 7.8695469 17.492922 6.2917656 25.345937 9.0097656 31.960938 C 10.693766 36.058937 7.9562031 38.935484 4.7832031 42.271484 C 3.6512031 43.460484 2.4804844 44.691719 1.5214844 46.011719 C 1.2224844 46.425719 1.2801563 46.998797 1.6601562 47.341797 C 1.8501562 47.513797 2.0900781 47.599609 2.3300781 47.599609 C 2.5680781 47.599609 2.8080469 47.515703 2.9980469 47.345703 L 17.335938 34.525391 C 17.482938 34.416391 17.599922 34.268797 17.669922 34.091797 C 17.822922 33.712797 17.728594 33.278094 17.433594 32.996094 C 14.748594 30.429094 14.157766 27.483844 14.134766 25.464844 C 14.099766 22.358844 15.354984 19.296453 17.583984 17.064453 C 20.080984 14.562453 23.836578 13.331469 27.392578 13.855469 C 27.595578 13.883469 27.810047 13.850906 27.998047 13.753906 L 33.689453 10.800781 C 34.024453 10.627781 34.232516 10.278391 34.228516 9.9003906 C 34.224516 9.5223906 34.006016 9.1796719 33.666016 9.0136719 C 33.269016 8.8206719 32.857031 8.6362812 32.457031 8.4882812 C 30.361094 7.6242188 28.17308 7.18078 25.996094 7.1367188 z" fill="currentColor"/>
              </svg>
              Grok
            </button>
            <button 
              class="quick-nav-btn" 
              :class="{ active: currentCategory === 'gemini' }" 
              @click="switchCategory('gemini')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
              Gemini
            </button>
          </div>
          <template v-if="availableSubCategories.length > 0">
            <div class="toolbar-divider"></div>
            <div class="sub-nav-inline">
              <button 
                v-for="sub in availableSubCategories" 
                :key="sub.key"
                class="sub-nav-btn" 
                :class="{ active: currentSubCategory === sub.key }"
                @click="currentSubCategory = sub.key"
              >
                {{ sub.name }}
              </button>
            </div>
          </template>
          <div class="search">
            <input v-model="searchKeyword" placeholder="实时搜索车队" />
          </div>
        </div>

        <!-- 车队内容容器 -->
        <div v-if="!iframeMode && !showProfile && !showMdConvert && !showCodex" id="fleetContainer">
          <!-- 加载中状态 -->
          <div v-if="isLoadingCars" class="loading-container">
            <div class="loading-spinner-large"></div>
            <p class="loading-text">正在加载车队数据...</p>
          </div>

          <!-- 车队列表 -->
          <div v-else v-for="category in filteredDisplayCategories" :key="category.key" class="category-section">
            <div class="fleet-content">
              <div v-for="car in category.cars" :key="car.carID" class="botcard" @click="handleCarClick(car.carID, category.type, car.isVirtual, category.realCarIDs)">
                <div class="botcard-hd">
                  <span v-html="getCategoryIcon(category.type)"></span>
                  <div v-if="category.type === 'gemini'" class="model-pills">
                    <!-- 左：Thinking -->
                    <span
                      class="model-dot-pill"
                      :class="{ ok: !car.isVirtual && !(car.clears_in_think > 0), busy: car.isVirtual || car.clears_in_think > 0 }"
                      :title="car.isVirtual ? 'Thinking 模型不可用' : (car.clears_in_think > 0 ? `Thinking 模型 ${formatCooldown(car.clears_in_think)} 后恢复` : 'Thinking 模型正常可用')"
                    ></span>
                    <!-- 右：Pro -->
                    <span
                      class="model-dot-pill"
                      :class="{ ok: !car.isVirtual && !(car.clears_in_pro > 0), busy: car.isVirtual || car.clears_in_pro > 0 }"
                      :title="car.isVirtual ? 'Pro 模型不可用' : (car.clears_in_pro > 0 ? `Pro 模型 ${formatCooldown(car.clears_in_pro)} 后恢复` : 'Pro 模型正常可用')"
                    ></span>
                  </div>
                  <div class="badge-container">
                    <div class="badge">{{ getBadgeType(car, category.type) }}</div>
                    <div v-if="car.isIQ" class="recommend-badge">推荐</div>
                  </div>
                </div>
                <div class="botcard-bd">
                  <div>{{ car.carID }}</div>
                  <div>{{ car.isVirtual ? '繁忙' : getCarStatus(car.count, category.type, category.key) }}</div>
                </div>
                <div class="prog">
                  <div :style="{ width: car.isVirtual ? '60%' : getProgressWidth(car.count, category.type, category.key) }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MD文件转换内容 -->
        <div v-if="showMdConvert && !iframeMode" class="md-convert-container">
          <div class="convert-card box">
            <h2 class="convert-title">Markdown 格式转换工具</h2>
            <p class="convert-sub">上传 .md 文件，一键转换为 DOCX / HTML / PDF / PNG</p>

            <!-- 拖拽上传 -->
            <div 
              class="drop-zone" 
              :class="{ 'drag-over': isDragOver, 'has-file': selectedFile }"
              @dragover.prevent="isDragOver = true"
              @dragleave.prevent="isDragOver = false"
              @drop.prevent="handleFileDrop"
              @click="triggerFileInput"
            >
              <input type="file" ref="fileInputRef" accept=".md" @change="handleFileSelect" style="display:none">
              <div class="drop-content">
                <div class="icon">{{ selectedFile ? '✅' : '📄' }}</div>
                <div v-if="selectedFile" class="filename">{{ selectedFile.name }}</div>
                <div v-else class="text">拖拽 .md 文件到此处，或点击选择</div>
                <div v-if="selectedFile" class="text-sm">{{ (selectedFile.size / 1024).toFixed(1) }} KB &nbsp;|&nbsp; 点击重新选择</div>
              </div>
            </div>

            <!-- 格式选择 -->
            <div class="format-group">
              <div 
                v-for="fmt in ['html', 'docx', 'pdf', 'png']" 
                :key="fmt"
                class="format-btn" 
                :class="{ active: selectedFormats[fmt] }"
                @click="toggleFormat(fmt)"
              >
                <span class="ext" v-html="getFormatIcon(fmt)"></span>
                <span class="label">{{ fmt.toUpperCase() }}</span>
              </div>
            </div>

            <!-- 转换按钮 -->
            <button 
              class="convert-btn" 
              :disabled="!canConvert || isConverting"
              @click="startConversion"
            >
              {{ convertBtnText }}
            </button>

            <!-- 状态提示 -->
            <div v-if="convertStatus" class="status-msg" :class="convertStatus.type">
              <span v-if="convertStatus.type === 'loading'" class="spinner-sm"></span>
              {{ convertStatus.msg }}
            </div>

            <div class="convert-info">
              支持格式：.md → DOCX / HTML / PDF / PNG<br>
              文件大小限制：10MB &nbsp;|&nbsp; 转换文件 10 分钟后自动清理
            </div>
          </div>
        </div>

        <!-- GPT Codex 内容 -->
        <div v-if="showCodex && !iframeMode" id="codexContainer">
          <CodexView
            :loading="codexLoading"
            :data="codexData"
            :notice="config.vibeCodeNotice || ''"
            @refresh="loadCodexQuota"
          />
        </div>

        <!-- 个人中心内容 -->
        <div v-if="showProfile && !iframeMode" id="profileContainer">
          <Profile 
            :user-info="userInfo" 
            @back="closeProfile" 
            @change-password="openChangePasswordModal"
            @logout="openLogoutModal"
          />
        </div>

        <!-- iframe内容容器 -->
        <div v-if="iframeMode" id="iframeContainer" class="iframe-fullheight">
          <iframe 
            :src="iframeUrl" 
            style="width:100%;height:100%;border:2px solid rgba(0,0,0,0.05);border-radius:16px;background:#fff"
          ></iframe>
        </div>
      </main>
    </div>

    <!-- 兑换码弹窗 -->
    <ExchangeModal
      :is-visible="showExchangeModal"
      :user-info="userInfo"
      @close="closeExchangeModal"
      @exchange="loadUserInfo"
    />

    <!-- 修改密码弹窗 -->
    <ChangePasswordModal
      :is-visible="showChangePasswordModal"
      :user-info="userInfo"
      @close="closeChangePasswordModal"
      @success="loadUserInfo"
    />

    <!-- 新PLUS站确认弹窗 -->
    <div v-if="showNewPlusSiteModal" class="modal-overlay" @click="closeNewPlusSiteModal">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <h3>前往新PLUS站</h3>
          <button class="modal-close" @click="closeNewPlusSiteModal">✕</button>
        </div>
        <div class="modal-content">
          <div class="confirm-content">
            <div class="confirm-icon">🚀</div>
            <p class="confirm-message">您确定要前往新PLUS站点吗？</p>
          </div>
        </div>
        <div class="modal-actions">
          <button class="tech-btn secondary" @click="closeNewPlusSiteModal">取消</button>
          <button class="tech-btn primary" @click="confirmGoToNewPlusSite">确认前往</button>
        </div>
      </div>
    </div>

    <!-- AI 绘图站跳转确认弹窗 -->
    <div v-if="showDrawingModal" class="modal-overlay" @click="closeDrawingModal">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <h3>前往 AI 绘图站</h3>
          <button class="modal-close" @click="closeDrawingModal">✕</button>
        </div>
        <div class="modal-content">
          <div class="confirm-content">
            <div class="confirm-icon">🎨</div>
            <p class="confirm-message">是否跳转到 AI 绘图站？</p>
          </div>
        </div>
        <div class="modal-actions">
          <button class="tech-btn secondary" @click="closeDrawingModal">取消</button>
          <button class="tech-btn primary" @click="confirmGoToDrawing">确认前往</button>
        </div>
      </div>
    </div>

    <!-- 微信浏览器强制拦截弹窗 -->
    <div v-if="showWechatWarning" class="modal-overlay wechat-warning-overlay">
      <div class="modal-container wechat-warning-modal" @click.stop>
        <div class="modal-content">
          <div class="confirm-content">
            <div class="confirm-icon">🚫</div>
            <p class="confirm-message">禁止在微信中使用</p>
            <p class="confirm-submessage">请复制链接到浏览器（如：Chrome、Safari、Edge）中打开</p>
            <div class="wechat-guide">
              <p class="guide-step">📱 操作步骤：</p>
              <p class="guide-step">1. 点击右上角 "..." 按钮</p>
              <p class="guide-step">2. 选择"在浏览器中打开"</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getConfig, getUserInfo, getCarList, getGrokCarList, getGeminiCarList, getUserSubscriptions, getVibeCodeQuota } from '../api/home'
import { loginSession } from '../api/auth'
import { OAUTH_URL, OAUTH_URL1, OAUTH_URL2, DRAWING_URL } from '../api/config'
import ExchangeModal from './ExchangeModal.vue'
import ChangePasswordModal from './ChangePasswordModal.vue'
import CodexView from './CodexView.vue'
import Profile from './Profile.vue'
import toast from '../utils/toast'

export default {
  name: 'CarList',
  components: { ExchangeModal, ChangePasswordModal, Profile, CodexView },
  setup() {
    const router = useRouter()
    
    const config = reactive({
      siteName: '',
      siteLogo: '',
      chatgptMenuName: '',
      chatgptNormalName: '',
      chatgptPlusName: '',
      chatgptProName: '',
      chatgptTeamName: '',
      grokMenuName: '',
      grokCarName: '',
      grokSuperName: '',
      geminiMenuName: '',
      geminiCarName: '',
      geminiProCarName: '',
      geminiUltraCarName: '',
      exchangeName: '',
      customMenuConfig: '[]',
      isAuthCodex: false,
      vibeCodeNotice: ''
    })

    const userInfo = reactive({
      email: '',
      expireTime: '未知',
      grokExpireTime: '未知',
      geminiExpireTime: '未知',
      userToken: '',
      isPro: true
    })

    const currentCategory = ref(localStorage.getItem('currentCategory') || 'chatgpt')
    const allCars = ref([])
    const carNotice = ref('')
    const searchKeyword = ref('')
    const currentSubCategory = ref('all')
    const isLoggedIn = ref(false) // 是否已登录
    const showProfile = ref(false)
    const showExchangeModal = ref(false)
    const showChangePasswordModal = ref(false)
    const showNewPlusSiteModal = ref(false)
    const showDrawingModal = ref(false)
    const showWechatWarning = ref(false) // 微信浏览器警告
    const isLoadingCars = ref(false) // 车队加载状态
    const isPageLoading = ref(true) // 页面加载状态（getConfig）
    const isJoiningCar = ref(false) // 进入车队加载状态
    
    // iframe 相关
    const iframeMode = ref(false)
    const iframeUrl = ref('')
    const iframeTitle = ref('')
    const currentMenuId = ref('')

    // GPT Codex 相关状态
    const showCodex = ref(false)
    const codexLoading = ref(false)
    const codexData = ref(null)

    // MD转换相关状态
    const showMdConvert = ref(false)
    const selectedFile = ref(null)
    const isDragOver = ref(false)
    const selectedFormats = reactive({ html: true, docx: false, pdf: false, png: false })
    const isConverting = ref(false)
    const convertStatus = ref(null)
    const fileInputRef = ref(null)
    const noticeIframeRef = ref(null)

    const noticeHtml = computed(() => {
      return `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>*{margin:0;padding:0;box-sizing:border-box}html,body{font-family:"KaiTi",serif;font-weight:700;color:#222;text-align:center;line-height:1.6;overflow:hidden}img{max-width:100%;height:auto}a{color:#7b5cff;text-decoration:underline}</style></head><body>${carNotice.value}</body></html>`
    })

    const resizeNoticeIframe = () => {
      const iframe = noticeIframeRef.value
      if (!iframe) return
      try {
        iframe.style.height = '0px'
        const h = iframe.contentDocument.documentElement.scrollHeight
        iframe.style.height = h + 'px'
      } catch (e) { /* cross-origin */ }
    }

    // 顶部用户名下方显示的有效期标签/时间（进入 Codex 视图时显示 Codex 订阅信息）
    const headerExpireLabel = computed(() => {
      if (showCodex.value) return 'Codex'
      if (currentCategory.value === 'grok') return 'Grok'
      if (currentCategory.value === 'gemini') return 'Gemini'
      return 'ChatGPT'
    })

    const headerExpireTime = computed(() => {
      if (showCodex.value) {
        const sub = codexData.value && codexData.value.codex && codexData.value.codex.subscriptions
        return sub && sub.expireTime ? sub.expireTime : ''
      }
      if (currentCategory.value === 'grok') return userInfo.grokExpireTime
      if (currentCategory.value === 'gemini') return userInfo.geminiExpireTime
      return userInfo.expireTime
    })

    // 自定义菜单
    const customMenus = computed(() => {
      try {
        const menus = JSON.parse(config.customMenuConfig || '[]')
        return menus.filter(m => m.enabled)
      } catch (e) {
        return []
      }
    })

    // 计算推荐车队数量（isIQ 为 true 的车队）
    const recommendedCarsCount = computed(() => {
      return allCars.value.filter(car => car.isIQ).length
    })

    // 计算进入新PLUS所需的最低时长
    const requiredHoursForNewPlus = computed(() => {
      return recommendedCarsCount.value >= 25 ? 25 : 6
    })

    // 图标映射
    const iconMap = {
      'icon-discover': '<svg viewBox="0 0 24 24"><path d="M12 1l3 6 6 .9-4.5 4.4 1 6.2L12 16l-5.5 2.5 1-6.2L3 7.9 9 7z"/></svg>',
      'icon-pending': '<svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 5v5l4 2"/></svg>',
      'icon-app': '<svg viewBox="0 0 24 24"><path d="M7 2h10v20H7zM4 6h3v12H4zm13 0h3v12h-3z"/></svg>',
      'icon-goods': '<svg viewBox="0 0 24 24"><path d="M12 8a4 4 0 100 8 4 4 0 000-8zm0-6a2 2 0 110 4 2 2 0 010-4zM4 12a2 2 0 114 0 2 2 0 01-4 0zm12 0a2 2 0 114 0 2 2 0 01-4 0z"/></svg>',
      'default': '<svg viewBox="0 0 24 24"><path d="M4 3h16v14H4zM2 19h20v2H2z"/></svg>'
    }

    const getIconSvg = (iconName) => {
      return iconMap[iconName] || iconMap['default']
    }

    // 获取分类图标
    const getCategoryIcon = (type) => {
      if (type === 'chatgpt') {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" style="width:100%;height:100%;fill:currentColor;">
          <path d="M 14.070312 2 C 11.330615 2 8.9844456 3.7162572 8.0390625 6.1269531 C 6.061324 6.3911222 4.2941948 7.5446684 3.2773438 9.3066406 C 1.9078196 11.678948 2.2198602 14.567816 3.8339844 16.591797 C 3.0745422 18.436097 3.1891418 20.543674 4.2050781 22.304688 C 5.5751778 24.677992 8.2359331 25.852135 10.796875 25.464844 C 12.014412 27.045167 13.895916 28 15.929688 28 C 18.669385 28 21.015554 26.283743 21.960938 23.873047 C 23.938676 23.608878 25.705805 22.455332 26.722656 20.693359 C 28.09218 18.321052 27.78014 15.432184 26.166016 13.408203 C 26.925458 11.563903 26.810858 9.4563257 25.794922 7.6953125 C 24.424822 5.3220082 21.764067 4.1478652 19.203125 4.5351562 C 17.985588 2.9548328 16.104084 2 14.070312 2 z M 14.070312 4 C 15.226446 4 16.310639 4.4546405 17.130859 5.2265625 C 17.068225 5.2600447 17.003357 5.2865019 16.941406 5.3222656 L 12.501953 7.8867188 C 12.039953 8.1527187 11.753953 8.6456875 11.751953 9.1796875 L 11.724609 15.146484 L 9.5898438 13.900391 L 9.5898438 8.4804688 C 9.5898438 6.0104687 11.600312 4 14.070312 4 z M 20.492188 6.4667969 C 21.927441 6.5689063 23.290625 7.3584375 24.0625 8.6953125 C 24.640485 9.696213 24.789458 10.862812 24.53125 11.958984 C 24.470201 11.920997 24.414287 11.878008 24.351562 11.841797 L 19.910156 9.2773438 C 19.448156 9.0113437 18.879016 9.0103906 18.416016 9.2753906 L 13.236328 12.236328 L 13.248047 9.765625 L 17.941406 7.0546875 C 18.743531 6.5915625 19.631035 6.4055313 20.492188 6.4667969 z M 7.5996094 8.2675781 C 7.5972783 8.3387539 7.5898438 8.4087418 7.5898438 8.4804688 L 7.5898438 13.607422 C 7.5898438 14.141422 7.8729844 14.635297 8.3339844 14.904297 L 13.488281 17.910156 L 11.34375 19.134766 L 6.6484375 16.425781 C 4.5094375 15.190781 3.7747656 12.443687 5.0097656 10.304688 C 5.5874162 9.3043657 6.522013 8.5923015 7.5996094 8.2675781 z M 18.65625 10.865234 L 23.351562 13.574219 C 25.490562 14.809219 26.225234 17.556313 24.990234 19.695312 C 24.412584 20.695634 23.477987 21.407698 22.400391 21.732422 C 22.402722 21.661246 22.410156 21.591258 22.410156 21.519531 L 22.410156 16.392578 C 22.410156 15.858578 22.127016 15.364703 21.666016 15.095703 L 16.511719 12.089844 L 18.65625 10.865234 z M 15.009766 12.947266 L 16.78125 13.980469 L 16.771484 16.035156 L 14.990234 17.052734 L 13.21875 16.017578 L 13.228516 13.964844 L 15.009766 12.947266 z M 18.275391 14.853516 L 20.410156 16.099609 L 20.410156 21.519531 C 20.410156 23.989531 18.399687 26 15.929688 26 C 14.773554 26 13.689361 25.54536 12.869141 24.773438 C 12.931775 24.739955 12.996643 24.713498 13.058594 24.677734 L 17.498047 22.113281 C 17.960047 21.847281 18.246047 21.354312 18.248047 20.820312 L 18.275391 14.853516 z M 16.763672 17.763672 L 16.751953 20.234375 L 12.058594 22.945312 C 9.9195938 24.180312 7.1725 23.443687 5.9375 21.304688 C 5.3595152 20.303787 5.2105423 19.137188 5.46875 18.041016 C 5.5297994 18.079003 5.5857129 18.121992 5.6484375 18.158203 L 10.089844 20.722656 C 10.551844 20.988656 11.120984 20.989609 11.583984 20.724609 L 16.763672 17.763672 z"></path>
        </svg>`
      } else if (type === 'grok') {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" style="width:100%;height:100%;fill:currentColor;">
          <path d="M 47.658203 2.0566406 C 47.415078 2.0662656 47.174734 2.1631563 46.990234 2.3476562 L 40.880859 8.4648438 C 40.833859 8.4968438 40.789047 8.5351719 40.748047 8.5761719 L 19.146484 30.304688 C 18.777484 30.675688 18.755656 31.266109 19.097656 31.662109 C 19.440656 32.058109 20.027219 32.1245 20.449219 31.8125 L 35.529297 20.667969 C 35.657297 20.572969 35.818125 20.540172 35.953125 20.576172 C 36.101125 20.617172 36.145156 20.725719 36.160156 20.761719 C 37.941156 25.057719 36.981844 29.949656 33.714844 33.222656 C 30.821844 36.118656 26.849547 37.186391 22.810547 36.150391 C 22.575547 36.090391 22.321516 36.119422 22.103516 36.232422 L 16.794922 38.984375 C 16.467922 39.153375 16.259906 39.489422 16.253906 39.857422 C 16.247906 40.225422 16.445625 40.566094 16.765625 40.746094 C 19.618625 42.341094 22.706953 43.119141 25.751953 43.119141 C 30.372953 43.119141 34.89475 41.326094 38.34375 37.871094 C 42.74375 33.467094 44.536297 27.227297 43.154297 21.154297 C 43.150297 21.114297 43.142812 21.073203 43.132812 21.033203 C 41.376812 13.469203 43.505828 10.537469 48.173828 4.1054688 L 48.507812 3.640625 C 48.813813 3.217625 48.741703 2.6309688 48.345703 2.2929688 C 48.147703 2.1249687 47.901328 2.0470156 47.658203 2.0566406 z M 25.996094 7.1367188 C 21.206724 7.0397839 16.477547 8.8765469 12.935547 12.419922 C 7.8695469 17.492922 6.2917656 25.345937 9.0097656 31.960938 C 10.693766 36.058937 7.9562031 38.935484 4.7832031 42.271484 C 3.6512031 43.460484 2.4804844 44.691719 1.5214844 46.011719 C 1.2224844 46.425719 1.2801563 46.998797 1.6601562 47.341797 C 1.8501562 47.513797 2.0900781 47.599609 2.3300781 47.599609 C 2.5680781 47.599609 2.8080469 47.515703 2.9980469 47.345703 L 17.335938 34.525391 C 17.482938 34.416391 17.599922 34.268797 17.669922 34.091797 C 17.822922 33.712797 17.728594 33.278094 17.433594 32.996094 C 14.748594 30.429094 14.157766 27.483844 14.134766 25.464844 C 14.099766 22.358844 15.354984 19.296453 17.583984 17.064453 C 20.080984 14.562453 23.836578 13.331469 27.392578 13.855469 C 27.595578 13.883469 27.810047 13.850906 27.998047 13.753906 L 33.689453 10.800781 C 34.024453 10.627781 34.232516 10.278391 34.228516 9.9003906 C 34.224516 9.5223906 34.006016 9.1796719 33.666016 9.0136719 C 33.269016 8.8206719 32.857031 8.6362812 32.457031 8.4882812 C 30.361094 7.6242188 28.17308 7.18078 25.996094 7.1367188 z"></path>
        </svg>`
      } else {
        // gemini
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:100%;height:100%;fill:currentColor;">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"></path>
        </svg>`
      }
    }

    // 获取徽章类型
    const getBadgeType = (car, type) => {
      if (type === 'chatgpt') {
        return car.isPro ? 'PRO' : car.isTeam ? 'TEAM' : car.isPlus ? 'PLUS' : '4o'
      } else if (type === 'grok') {
        return car.isSuperPro ? 'SuperPro' : car.isSuper ? 'Super' : '普号'
      } else {
        // gemini
        return car.isUltra ? 'ULTRA' : car.isPro ? 'PRO' : '普号'
      }
    }

    const getThresholds = (type, key) => {
      if (type === 'chatgpt') {
        if (key === 'team') return [40, 100]
        return [40, 80]
      }
      if (type === 'grok') return [40, 100]
      if (type === 'gemini') {
        if (key === 'ultra') return [60, 130]
        return [40, 80]
      }
      return [40, 80]
    }

    // GPT 类型不显示"繁忙"，最高停在"正常"
    const noBusy = (type) => type === 'chatgpt'

    // 把冷却秒数格式化为可读文字
    const formatCooldown = (sec) => {
      const n = Math.max(0, Math.floor(Number(sec) || 0))
      if (n <= 0) return ''
      if (n < 60) return `${n}s`
      const m = Math.floor(n / 60)
      if (m < 60) return `${m}m`
      const h = Math.floor(m / 60)
      const rm = m % 60
      return rm > 0 ? `${h}h${rm}m` : `${h}h`
    }

    const getCarStatus = (count, type, key) => {
      const num = Number(count) || 0
      const [idleMax, normMax] = getThresholds(type, key)
      if (num <= idleMax) return '空闲'
      if (num <= normMax) return '正常'
      return noBusy(type) ? '正常' : '繁忙'
    }

    const getProgressWidth = (count, type, key) => {
      const num = Number(count) || 0
      const [idleMax, normMax] = getThresholds(type, key)
      if (num <= idleMax) return '5%'
      if (num <= normMax) return '20%'
      return noBusy(type) ? '20%' : '60%'
    }

    // 格式化过期时间显示
    const formatExpireTime = (expireTime) => {
      if (!expireTime || expireTime === '未知') return '无有效订阅'
      // ISO 格式（如 Codex 返回的 2026-04-23T20:08:12.727+08:00）转为 YYYY-MM-DD HH:mm:ss
      if (typeof expireTime === 'string' && expireTime.includes('T')) {
        const d = new Date(expireTime)
        if (!isNaN(d.getTime())) {
          const pad = (n) => String(n).padStart(2, '0')
          return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        }
      }
      return expireTime
    }

    // 生成虚拟车队的函数
    const generateVirtualCars = (count, prefix, isPro = false, isUltra = false) => {
      const virtualCars = []
      for (let i = 1; i <= count; i++) {
        virtualCars.push({
          carID: `${prefix}${i}`,
          count: Math.floor(Math.random() * 31) + 10, // 随机生成10-40之间的count
          isPro: isPro,
          isUltra: isUltra,
          isVirtual: true // 标记为虚拟车队
        })
      }
      return virtualCars
    }

    // 计算显示的分类（根据搜索关键词过滤）
    const displayCategories = computed(() => {
      const keyword = searchKeyword.value.toLowerCase().trim()
      const categories = []

      const sortByCount = (cars) => [...cars].sort((a, b) => (Number(a.count) || 0) - (Number(b.count) || 0))

      // Gemini 排序：
      //   0 - 全部可用（最前）
      //   1 - Thinking 不可用（Pro 还能用）
      //   2 - Pro 不可用（Thinking 还能用）
      //   3 - 两个都不可用 / 虚拟车队（最后）
      // 同组内按 count 升序
      const limitRank = (c) => {
        if (c.isVirtual) return 3
        const proBusy = (Number(c.clears_in_pro) || 0) > 0
        const thinkBusy = (Number(c.clears_in_think) || 0) > 0
        if (proBusy && thinkBusy) return 3
        if (proBusy) return 2
        if (thinkBusy) return 1
        return 0
      }
      const geminiCarSorter = (a, b) => {
        const ra = limitRank(a)
        const rb = limitRank(b)
        if (ra !== rb) return ra - rb
        return (Number(a.count) || 0) - (Number(b.count) || 0)
      }

      if (currentCategory.value === 'chatgpt') {
        // PRO
        if (config.chatgptProName && config.chatgptProName.trim() !== '') {
          const proCars = allCars.value.filter(car => car.isPro)
          const filteredCars = keyword 
            ? proCars.filter(car => car.carID.toLowerCase().includes(keyword))
            : proCars
          if (filteredCars.length > 0) {
            categories.push({ key: 'pro', name: config.chatgptProName, cars: sortByCount(filteredCars), type: 'chatgpt' })
          }
        }
        
        // TEAM
        const teamCars = allCars.value.filter(car => car.isTeam)
        const filteredTeamCars = keyword 
          ? teamCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : teamCars
        if (filteredTeamCars.length > 0) {
          categories.push({ key: 'team', name: config.chatgptTeamName, cars: sortByCount(filteredTeamCars), type: 'chatgpt' })
        }
        
        // PLUS
        const plusCars = allCars.value.filter(car => car.isPlus && !car.isTeam && !car.isPro)
        const filteredPlusCars = keyword 
          ? plusCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : plusCars
        if (filteredPlusCars.length > 0) {
          categories.push({ key: 'plus', name: config.chatgptPlusName, cars: sortByCount(filteredPlusCars), type: 'chatgpt' })
        }
        
        // NORMAL
        const normalCars = allCars.value.filter(car => !car.isPlus && !car.isPro && !car.isTeam)
        const filteredNormalCars = keyword 
          ? normalCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : normalCars
        if (filteredNormalCars.length > 0) {
          categories.push({ key: 'normal', name: config.chatgptNormalName, cars: sortByCount(filteredNormalCars), type: 'chatgpt' })
        }
      } else if (currentCategory.value === 'grok') {
        // Super
        const superCars = allCars.value.filter(car => car.isSuper || car.isSuperPro)
        const filteredSuperCars = keyword 
          ? superCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : superCars
        if (filteredSuperCars.length > 0) {
          categories.push({ key: 'super', name: config.grokSuperName, cars: filteredSuperCars, type: 'grok' })
        }
        
        // Normal
        const normalCars = allCars.value.filter(car => !car.isSuper && !car.isSuperPro)
        const filteredNormalCars = keyword 
          ? normalCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : normalCars
        if (filteredNormalCars.length > 0) {
          categories.push({ key: 'normal', name: config.grokCarName, cars: filteredNormalCars, type: 'grok' })
        }
      } else if (currentCategory.value === 'gemini') {
        // Ultra
        if (config.geminiUltraCarName && config.geminiUltraCarName.trim() !== '') {
          const ultraCars = allCars.value.filter(car => car.isUltra)
          const filteredUltraCars = keyword 
            ? ultraCars.filter(car => car.carID.toLowerCase().includes(keyword))
            : ultraCars
          
          // 只有当有真实车辆时，才添加虚拟车队
          if (filteredUltraCars.length > 0) {
            let displayCars = [...filteredUltraCars]
            // 如果没有搜索关键词，添加10个虚拟车队
            if (!keyword) {
              const virtualCars = generateVirtualCars(10, 'xnqwe', false, true)
              displayCars = [...displayCars, ...virtualCars]
              // 限速/虚拟的排到后面，其余按count升序
              displayCars.sort(geminiCarSorter)
            }
            categories.push({ 
              key: 'ultra', 
              name: config.geminiUltraCarName, 
              cars: displayCars, 
              type: 'gemini',
              realCarIDs: [...filteredUltraCars].sort(geminiCarSorter).map(car => car.carID) // 与展示顺序一致，限速排后
            })
          }
        }
        
        // PRO
        if (config.geminiProCarName && config.geminiProCarName.trim() !== '') {
          const proCars = allCars.value.filter(car => car.isPro && !car.isUltra)
          const filteredCars = keyword 
            ? proCars.filter(car => car.carID.toLowerCase().includes(keyword))
            : proCars
          
          // 只有当有真实车辆时，才添加虚拟车队
          if (filteredCars.length > 0) {
            let displayCars = [...filteredCars]
            // 如果没有搜索关键词，添加30个虚拟车队
            if (!keyword) {
              const virtualCars = generateVirtualCars(50, 'xnqwe', true, false)
              displayCars = [...displayCars, ...virtualCars]
              // 限速/虚拟的排到后面，其余按count升序
              displayCars.sort(geminiCarSorter)
            }
            categories.push({ 
              key: 'pro', 
              name: config.geminiProCarName, 
              cars: displayCars, 
              type: 'gemini',
              realCarIDs: [...filteredCars].sort(geminiCarSorter).map(car => car.carID) // 与展示顺序一致，限速排后
            })
          }
        }
        
        // Normal
        const normalCars = allCars.value.filter(car => !car.isPro && !car.isUltra)
        const filteredNormalCars = keyword 
          ? normalCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : normalCars
        if (filteredNormalCars.length > 0) {
          categories.push({ key: 'normal', name: config.geminiCarName, cars: filteredNormalCars, type: 'gemini' })
        }
      }

      const normalCats = categories.filter(c => c.key === 'normal')
      const nonNormalCats = categories.filter(c => c.key !== 'normal')

      nonNormalCats.sort((a, b) => {
        const sortable = (cat) => {
          let cars = cat.cars.filter(c => !c.isVirtual)
          if (cat.type === 'chatgpt') cars = cars.filter(c => c.isIQ)
          return cars
        }
        const aR = sortable(a), bR = sortable(b)

        // Gemini 子分类（ultra/pro）：Pro 和 Thinking 都可用的车队多者排前
        if (a.type === 'gemini' && b.type === 'gemini') {
          const fullyAvailable = (c) => (Number(c.clears_in_pro) || 0) === 0 && (Number(c.clears_in_think) || 0) === 0
          const aOk = aR.filter(fullyAvailable).length
          const bOk = bR.filter(fullyAvailable).length
          if (aOk !== bOk) return bOk - aOk
        }

        const [aIMax, aNMax] = getThresholds(a.type, a.key)
        const [bIMax, bNMax] = getThresholds(b.type, b.key)

        const aIdle = aR.filter(c => (Number(c.count) || 0) <= aIMax).length
        const bIdle = bR.filter(c => (Number(c.count) || 0) <= bIMax).length
        if (aIdle !== bIdle) return bIdle - aIdle

        const aNorm = aR.filter(c => { const n = Number(c.count) || 0; return n > aIMax && n <= aNMax }).length
        const bNorm = bR.filter(c => { const n = Number(c.count) || 0; return n > bIMax && n <= bNMax }).length
        if (aNorm !== bNorm) return bNorm - aNorm

        const aBusy = aR.filter(c => (Number(c.count) || 0) > aNMax).length
        const bBusy = bR.filter(c => (Number(c.count) || 0) > bNMax).length
        return bBusy - aBusy
      })

      return [...nonNormalCats, ...normalCats]
    })

    // 子分类标签列表（不含"全部"）
    const availableSubCategories = computed(() => {
      const cats = displayCategories.value
      if (cats.length <= 1) return []
      return cats.map(cat => ({ key: cat.key, name: cat.name }))
    })

    // 按子分类过滤后的展示数据
    const filteredDisplayCategories = computed(() => {
      if (currentSubCategory.value === 'all') {
        return displayCategories.value
      }
      const matched = displayCategories.value.filter(c => c.key === currentSubCategory.value)
      if (matched.length === 0 && displayCategories.value.length > 0) {
        return [displayCategories.value[0]]
      }
      return matched
    })

    // 当子分类因搜索等原因消失时，回退到"全部"
    watch(() => availableSubCategories.value, (subs) => {
      if (currentSubCategory.value !== 'all' && subs.length > 0) {
        const exists = subs.some(s => s.key === currentSubCategory.value)
        if (!exists) {
          currentSubCategory.value = 'all'
        }
      }
    })

    // 检查是否有 share-session cookie
    const hasShareSession = () => {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'share-session' && value && value.trim() !== '') {
          return true
        }
      }
      return false
    }

    // 获取 share-session cookie 的值
    const getShareSessionValue = () => {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'share-session') {
          return value || ''
        }
      }
      return ''
    }

    // 加载配置
    const loadConfig = async () => {
      isPageLoading.value = true
      try {
        const res = await getConfig()
        if (res.code === 1 && res.data) {
          Object.assign(config, res.data)
        }
      } catch (error) {
        console.error('加载配置失败:', error)
      } finally {
        isPageLoading.value = false
      }
    }

    // 加载用户信息
    const loadUserInfo = async () => {
      const sessionValue = getShareSessionValue()
      console.log('🔍 当前 share-session cookie 值:', sessionValue ? '有值' : '无值或空值')

      // 只有存在 share-session cookie 时才请求用户信息
      if (!hasShareSession()) {
        console.log('❌ 未检测到有效的 share-session cookie，跳过用户信息请求')
        isLoggedIn.value = false
        return
      }

      console.log('✅ 检测到有效的 share-session cookie，开始请求用户信息')

      try {
        const res = await getUserInfo()
        console.log('📡 getUserInfo 响应:', res)

        if (res.code === 1 && res.data) {
          console.log('📋 用户数据详情:', res.data)

          // 判断是否为游客
          // 游客返回: {"code":1,"data":{"name":"游客"}}
          // 用户返回: {"code":1,"data":{"email":"...","expireTime":"...","userToken":"..."}}
          if (res.data.name === '游客') {
            console.log('👤 用户状态：游客或无效用户')
            isLoggedIn.value = false
          } else {
            console.log('✅ 用户状态：已登录', res.data.userToken)
            isLoggedIn.value = true
            Object.assign(userInfo, res.data)
          }
        } else {
          console.log('❌ API返回码非1:', res.code, res.msg || '无消息')
          isLoggedIn.value = false
        }
      } catch (error) {
        console.error('❌ 加载用户信息失败:', error)
        isLoggedIn.value = false
      }
    }

    // 加载车队列表
    const loadCarList = async () => {
      try {
        const res = currentCategory.value === 'chatgpt'
          ? await getCarList()
          : currentCategory.value === 'grok'
          ? await getGrokCarList()
          : await getGeminiCarList()

        if (res.code === 1 && res.data) {
          allCars.value = res.data.list || []
          carNotice.value = res.data.notice || ''
        }
      } catch (error) {
        console.error('加载车队列表失败:', error)
      }
    }

    // 切换分类
    const switchCategory = async (category) => {
      if (iframeMode.value) closeIframe()
      if (showProfile.value) showProfile.value = false
      if (showMdConvert.value) showMdConvert.value = false // 关闭MD转换
      if (showCodex.value) showCodex.value = false // 关闭Codex
      
      currentCategory.value = category
      searchKeyword.value = ''
      currentSubCategory.value = 'all'
      
      // 保存当前分类到 localStorage
      localStorage.setItem('currentCategory', category)
      
      // 加载车辆列表
      isLoadingCars.value = true
      await loadCarList()
      isLoadingCars.value = false
      
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    // 打开iframe
    const openInIframe = (url, title, id) => {
      showProfile.value = false
      showMdConvert.value = false // 关闭MD转换
      showCodex.value = false // 关闭Codex
      iframeMode.value = true
      iframeUrl.value = url
      iframeTitle.value = title
      currentMenuId.value = id
      
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    // 关闭iframe
    const closeIframe = () => {
      iframeMode.value = false
      iframeUrl.value = ''
      iframeTitle.value = ''
      currentMenuId.value = ''
    }

    // 打开个人中心
    const openProfile = () => {
      showProfile.value = true
      showMdConvert.value = false // 关闭MD转换
      showCodex.value = false // 关闭Codex
      iframeMode.value = false
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    const closeProfile = () => {
      showProfile.value = false
    }

    // 打开MD转换界面
    const openMdConvert = () => {
      showMdConvert.value = true
      showProfile.value = false
      showCodex.value = false
      iframeMode.value = false
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    // 加载 Codex 配额
    const loadCodexQuota = async () => {
      codexLoading.value = true
      try {
        const res = await getVibeCodeQuota()
        if (res.code === 1 && res.data) {
          codexData.value = res.data
        } else {
          toast.error(res.msg || '获取 Codex 配额失败')
        }
      } catch (error) {
        console.error('❌ 获取 Codex 配额失败:', error)
        toast.error('获取 Codex 配额失败')
      } finally {
        codexLoading.value = false
      }
    }

    // 打开 GPT Codex 界面
    const openCodex = () => {
      if (!isLoggedIn.value) {
        toast.info('请先登录')
        router.push('/login')
        return
      }
      showCodex.value = true
      showMdConvert.value = false
      showProfile.value = false
      iframeMode.value = false
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
      loadCodexQuota()
    }

    // AI 绘图站地址（前端常量）
    const drawingUrl = DRAWING_URL

    // 打开 AI 绘图站确认弹窗
    const goToDrawing = () => {
      if (!drawingUrl) return
      if (!hasShareSession() || !isLoggedIn.value) {
        toast.info('请先登录')
        router.push('/login')
        return
      }
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
      showDrawingModal.value = true
    }

    const closeDrawingModal = () => {
      showDrawingModal.value = false
    }

    // 确认跳转：构造表单 POST 到绘图站 /sso-login（新标签页打开，方便排查）
    const confirmGoToDrawing = () => {
      const token = getShareSessionValue()
      if (!token) {
        toast.info('请先登录')
        router.push('/login')
        return
      }
      const base = String(drawingUrl).replace(/\/+$/, '')
      const action = `${base}/sso-login`
      const targetName = 'ai_drawing_sso_' + Date.now()

      const form = document.createElement('form')
      form.setAttribute('method', 'POST')
      form.setAttribute('action', action)
      form.setAttribute('enctype', 'application/x-www-form-urlencoded')
      form.setAttribute('accept-charset', 'UTF-8')
      form.setAttribute('target', targetName)
      form.style.display = 'none'

      const tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'share-token'
      tokenInput.value = token
      form.appendChild(tokenInput)

      const returnInput = document.createElement('input')
      returnInput.type = 'hidden'
      returnInput.name = 'return_url'
      returnInput.value = window.location.origin
      form.appendChild(returnInput)

      document.body.appendChild(form)

      const newWin = window.open('about:blank', targetName)
      if (!newWin) {
        toast.error('浏览器已拦截弹窗，请允许弹窗后重试')
        document.body.removeChild(form)
        return
      }
      form.submit()
      setTimeout(() => {
        try { document.body.removeChild(form) } catch (e) { /* ignore */ }
        showDrawingModal.value = false
      }, 500)
    }

    // MD文件处理
    const triggerFileInput = () => {
      fileInputRef.value && fileInputRef.value.click()
    }

    const handleFileSelect = (e) => {
      if (e.target.files.length > 0) {
        processFile(e.target.files[0])
      }
    }

    const handleFileDrop = (e) => {
      isDragOver.value = false
      if (e.dataTransfer.files.length > 0) {
        processFile(e.dataTransfer.files[0])
      }
    }

    const processFile = (file) => {
      if (!file.name.toLowerCase().endsWith('.md')) {
        toast.error('仅支持 .md 文件')
        return
      }
      selectedFile.value = file
      convertStatus.value = null
    }

    const toggleFormat = (fmt) => {
      selectedFormats[fmt] = !selectedFormats[fmt]
    }

    const getFormatIcon = (fmt) => {
      // 请在这里替换 SVG 代码
      const icons = { 
        docx: `<svg t="1770379185005" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9702" width="32" height="32"><path d="M967.111111 281.6V910.222222c0 62.577778-51.2 113.777778-113.777778 113.777778H170.666667c-62.577778 0-113.777778-51.2-113.777778-113.777778V113.777778c0-62.577778 51.2-113.777778 113.777778-113.777778h514.844444L967.111111 281.6z" fill="#4F6BF6" p-id="9703"></path><path d="M581.262222 755.626667h59.363556L739.555556 439.04h-59.335112z" fill="#FFFFFF" p-id="9704"></path><path d="M685.511111 224.711111V0L967.111111 281.6H742.4c-31.288889 0-56.888889-25.6-56.888889-56.888889" fill="#243EBB" p-id="9705"></path><path d="M640.625778 755.626667h-59.363556l-98.929778-277.020445h59.335112zM442.737778 755.626667h-59.363556L284.444444 439.04h59.335112z" fill="#FFFFFF" p-id="9706"></path><path d="M383.374222 755.626667h59.363556l98.929778-277.020445h-59.335112z" fill="#FFFFFF" p-id="9707"></path></svg>`, 
        html: `<svg t="1770379254948" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10870" width="32" height="32"><path d="M145.6 0c-44.8 0-80 36.8-80 81.6v860.8c0 44.8 35.2 81.6 80 81.6h732.8c44.8 0 81.6-36.8 81.6-81.6V324.8L657.6 0h-512z" fill="#F7622C" p-id="10871"></path><path d="M960 326.4v16H755.2s-100.8-20.8-99.2-108.8c0 0 4.8 92.8 97.6 92.8H960z" fill="#F54921" p-id="10872"></path><path d="M657.6 0v233.6c0 25.6 17.6 92.8 97.6 92.8H960L657.6 0z" fill="#FFFFFF" p-id="10873"></path><path d="M366.4 812.8h-4.8L240 758.4c-8-3.2-12.8-11.2-12.8-20.8 0-8 4.8-16 12.8-19.2l121.6-54.4c1.6 0 3.2-1.6 4.8-1.6 8 0 14.4 6.4 14.4 14.4 0 6.4-3.2 11.2-8 14.4l-112 48 112 46.4c4.8 3.2 8 8 8 14.4 0 8-6.4 12.8-14.4 12.8z m136-176L432 849.6c-3.2 6.4-8 9.6-14.4 9.6-9.6 0-16-6.4-16-14.4 0-1.6 1.6-3.2 1.6-4.8l70.4-211.2c3.2-6.4 8-11.2 14.4-11.2 9.6 0 14.4 6.4 14.4 14.4v4.8z m163.2 121.6L544 812.8h-4.8c-8 0-14.4-4.8-14.4-12.8 0-6.4 3.2-11.2 8-14.4l113.6-46.4-113.6-48c-4.8-3.2-8-8-8-14.4 0-8 6.4-14.4 14.4-14.4 1.6 0 3.2 1.6 4.8 1.6l121.6 54.4c8 3.2 12.8 11.2 12.8 19.2 0 9.6-4.8 17.6-12.8 20.8z" fill="#FFFFFF" p-id="10874"></path></svg>`, 
        pdf: `<svg t="1770379279810" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11991" width="32" height="32"><path d="M663.49568 80H195.2c-31.81056 0-57.6 25.78944-57.6 57.6V915.20512c0 15.90272 6.44096 30.30528 16.87552 40.72448a57.42592 57.42592 0 0 0 40.72448 16.87552h633.6c31.81056 0 57.6-25.78944 57.6-57.6V302.90432l-222.90432-222.90432z" fill="" p-id="11992"></path><path d="M663.49568 51.2H195.2c-31.81056 0-57.6 25.78944-57.6 57.6V886.40512c0 15.90272 6.44096 30.30528 16.87552 40.72448a57.42592 57.42592 0 0 0 40.72448 16.87552h633.6c31.81056 0 57.6-25.78944 57.6-57.6V274.10432L663.49568 51.2z" fill="#EF4A4A" p-id="11993"></path><path d="M764.4672 152.17152l-100.6336 100.62848 222.5664 222.5664V274.10432z" fill="" p-id="11994"></path><path d="M663.49568 51.2h-7.49568v172.8c0 31.81056 25.78944 57.6 57.6 57.6h172.8v-7.49568L663.49568 51.2z" fill="#F19A9A" p-id="11995"></path><path d="M688.83456 583.296c14.07488 7.90528 12.06272 13.824 22.1184 5.91872 10.05568-7.90016-10.05568-17.77664-26.1376-23.69536-16.09216-5.92896-92.52864-15.2832-92.52864-15.2832s4.81792 6.45632 11.34592 13.06624c12.12416 6.08768 22.93248 10.07104 30.90944 13.9776 16.35328-0.28672 42.41408-0.65024 54.29248 6.016z m21.69856 21.61152c-10.05568-5.91872-47.85664-11.74016-71.9872-25.56416-1.22368-0.70656-2.60608-1.3824-4.00896-2.06336-3.03616 0.04096-5.85216 0.09728-8.05376 0.09728-7.21408 0-15.98976-7.13216-22.85568-14.07488-28.07808-14.09024-63.09376-39.74144-85.76512-103.90528 0 0-14.08-51.35872-16.08704-69.13024-2.01216-17.76128 6.03136-35.54816 10.05056-19.74272 0 0 8.04352 17.77664 4.02432 31.59552l4.02432 23.69536s14.07488-51.33824 4.0192-65.1776c0 0-37.99552-21.7088-40.00256 11.86816-2.01216 33.56672 2.10944 82.63168 6.12864 90.53696 0 0-39.9104 120.24832-92.20608 193.3312 0 0-22.1184 31.58528-32.17408 35.54816 0 0-24.14592 9.87648-8.05888-11.8528 0 0 38.2208-43.44832 46.26432-55.296 0 0-69.97504 39.50592-73.99936 49.36192-4.0192 9.88672-13.9776 29.73184 11.64288 39.50592 0 0 29.54752 2.39104 51.66592-21.30432 0 0 51.87584-63.29344 61.93152-83.04128 0 0 32.60928-11.9552 141.21472-31.70816 0 0 58.33216 27.44832 76.44672 31.3856 18.09408 3.96288 26.1376 17.77664 26.1376 17.77664s21.70368-15.90272 11.648-21.84192z m-245.38624-21.0944l42.56256-83.47136c4.02432 19.75808 43.1872 57.9072 43.1872 57.9072-16.08704 1.9712-85.74976 25.56416-85.74976 25.56416z" fill="" p-id="11996"></path><path d="M688.83456 554.496c14.07488 7.90528 12.06272 13.824 22.1184 5.91872 10.05568-7.8848-10.05568-17.76128-26.1376-23.69536-16.09216-5.92896-92.52864-15.2832-92.52864-15.2832s4.81792 6.45632 11.34592 13.06624c12.12416 6.08768 22.93248 10.07104 30.90944 13.9776 16.35328-0.28672 42.41408-0.65024 54.29248 6.016z m21.69856 21.61152c-10.05568-5.91872-47.85664-11.74016-71.9872-25.56416-1.22368-0.70656-2.60608-1.3824-4.00896-2.06336-3.03616 0.04096-5.85216 0.09728-8.05376 0.09728-7.21408 0-15.98976-7.13216-22.85568-14.07488-28.07808-14.09024-63.09376-39.74144-85.76512-103.90528 0 0-14.08-51.35872-16.08704-69.13024-2.01216-17.76128 6.03136-35.54816 10.05056-19.74272 0 0 8.04352 17.77664 4.02432 31.59552l4.02432 23.69536s14.07488-51.33824 4.0192-65.1776c0 0-37.99552-21.7088-40.00256 11.86816-2.01216 33.56672 2.10944 82.63168 6.12864 90.53696 0 0-39.9104 120.24832-92.20608 193.3312 0 0-22.1184 31.58528-32.17408 35.54816 0 0-24.14592 9.87648-8.05888-11.8528 0 0 38.2208-43.44832 46.26432-55.296 0 0-69.97504 39.50592-73.99936 49.36192-4.0192 9.88672-13.9776 29.73184 11.64288 39.50592 0 0 29.54752 2.39104 51.66592-21.30432 0 0 51.87584-63.29344 61.93152-83.04128 0 0 32.60928-11.9552 141.21472-31.70816 0 0 58.33216 27.44832 76.44672 31.3856 18.09408 3.96288 26.1376 17.77664 26.1376 17.77664s21.70368-15.90272 11.648-21.84192z m-245.38624-21.0944l42.56256-83.47136c4.02432 19.75808 43.1872 57.9072 43.1872 57.9072-16.08704 1.9712-85.74976 25.56416-85.74976 25.56416z" fill="#FFFFFF" p-id="11997"></path></svg>`, 
        png: `<svg t="1770379309060" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13133" width="32" height="32"><path d="M901.851653 926.484607a48.255937 48.255937 0 0 1-14.274541 34.442195 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.220097 48.220097 0 0 1-34.457555-14.279661 48.844737 48.844737 0 0 1-14.279662-34.442195V48.846068a48.317377 48.317377 0 0 1 14.279662-34.467795A48.844737 48.844737 0 0 1 170.419644 0.001331h418.800096a48.742337 48.742337 0 0 1 34.662355 14.131182l263.858857 263.910057a48.844737 48.844737 0 0 1 14.110701 34.667475z" fill="#EBECF0" p-id="13134"></path><path d="M901.851653 926.484607v48.767936a48.317377 48.317377 0 0 1-14.274541 34.467796 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.844737 48.844737 0 0 1-48.788417-48.844737v-48.721856a48.204737 48.204737 0 0 0 14.279662 34.442195 48.844737 48.844737 0 0 0 34.457555 14.279661h682.648713a48.844737 48.844737 0 0 0 48.773056-48.783296z" fill="#C1C7D0" p-id="13135"></path><path d="M24.167034 536.423034h975.153932v243.849923a48.921536 48.921536 0 0 1-48.721856 48.844736H73.011771a48.342977 48.342977 0 0 1-34.467796-14.274541 48.844737 48.844737 0 0 1-14.376941-34.570195z" fill="#88C057" p-id="13136"></path><path d="M121.733627 536.412794V438.856441L24.167034 536.412794z m780.118026 0l0.926719-97.556353 97.039234 97.556353z" fill="#497F16" p-id="13137"></path><path d="M901.851653 312.628125v6.860791h-263.833257a48.844737 48.844737 0 0 1-48.844736-48.844737V0.001331a48.732097 48.732097 0 0 1 34.662355 14.115822l264.268456 263.751337a49.459136 49.459136 0 0 1 13.701102 34.754515z" fill="#C1C7D0" p-id="13138"></path><path d="M285.711654 773.954885h-59.033523v-181.027605h86.579087q75.750302 0.988159 77.726619 60.999601-0.993279 62.970798-75.760541 63.948717h-29.511642z m0-98.385792h24.596448q23.608289 0 23.61341-21.642212 0-18.687976-31.48796-18.698216h-16.721898zM465.75622 592.92728l64.936876 98.380672-1.966078-41.318346v-57.062326h57.067446v181.027605H529.715177l-64.941996-98.385792 2.954237 41.318346v57.067446H410.665092v-181.027605zM795.355792 674.586054v99.368831h-38.37435l-1.966078-17.710057q-17.710057 20.664293-55.091128 20.659173-84.63349-3.937275-87.567246-91.494281 4.910074-93.460359 94.448517-97.402753 72.796065 1.976317 86.579087 66.897833h-57.062326q-5.903352-22.620131-30.4998-22.625251-33.459157 0.993279-34.437075 53.125051 0.967679 49.213376 38.36923 49.198016 23.618529-2.949116 30.4998-20.664293h-26.562525v-39.352269z" fill="#FFFFFF" p-id="13139"></path></svg>` 
      }
      return icons[fmt] || '📄'
    }

    const canConvert = computed(() => {
      return selectedFile.value && Object.values(selectedFormats).some(v => v)
    })

    const convertBtnText = computed(() => {
      const fmts = Object.keys(selectedFormats).filter(k => selectedFormats[k])
      if (!selectedFile.value) return '请选择文件'
      if (fmts.length === 0) return '请选择格式'
      if (isConverting.value) return '正在转换...'
      return '转换为 ' + fmts.map(f => f.toUpperCase()).join(' + ')
    })

    const startConversion = async () => {
      if (!canConvert.value || isConverting.value) return

      const fmts = Object.keys(selectedFormats).filter(k => selectedFormats[k])
      isConverting.value = true
      convertStatus.value = { type: 'loading', msg: `正在转换 0/${fmts.length} ...` }

      let doneCount = 0
      const okList = []
      const failList = []

      // 并发还是串行？这里用串行保险一点
      for (const fmt of fmts) {
        try {
          const formData = new FormData()
          formData.append('file', selectedFile.value)
          formData.append('format', fmt)

          const response = await fetch('/format_conversion', {
            method: 'POST',
            body: formData
          })

          if (response.ok) {
            // 检查是不是 JSON 错误
            const contentType = response.headers.get('content-type')
            if (contentType && contentType.includes('application/json')) {
              const err = await response.json()
              failList.push(`${fmt.toUpperCase()}(${err.msg})`)
            } else {
              // 成功，下载文件
              const blob = await response.blob()
              const url = window.URL.createObjectURL(blob)
              const a = document.createElement('a')
              const baseName = selectedFile.value.name.replace(/\.md$/i, '')
              a.href = url
              a.download = `${baseName}.${fmt}`
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)
              window.URL.revokeObjectURL(url)
              okList.push(fmt.toUpperCase())
            }
          } else {
            failList.push(`${fmt.toUpperCase()}(HTTP ${response.status})`)
          }
        } catch (e) {
          failList.push(`${fmt.toUpperCase()}(网络错误)`)
        }
        
        doneCount++
        if (doneCount < fmts.length) {
          convertStatus.value = { type: 'loading', msg: `正在转换 ${doneCount}/${fmts.length} ...` }
        }
      }

      isConverting.value = false
      let msg = ''
      if (okList.length > 0) msg += okList.join('、') + ' 转换成功'
      if (failList.length > 0) msg += (msg ? '；' : '') + failList.join('、') + ' 失败'
      
      const type = failList.length > 0 ? (okList.length > 0 ? 'loading' : 'error') : 'success' 
      // success 绿, error 红, loading 蓝(混合)
      // 注意：这里的 'loading' 样式是蓝色的，刚好适合部分成功的情况
      
      convertStatus.value = { type: type === 'loading' ? 'loading' : type, msg }
      if (type === 'success') {
        toast.success(msg)
      } else if (failList.length > 0) {
        toast.error(msg)
      }
    }

    // 兑换码弹窗
    const openExchangeModal = () => { showExchangeModal.value = true }
    const closeExchangeModal = () => { showExchangeModal.value = false }

    // 处理兑换码
    const handleExchange = () => {
      const code = prompt('请输入兑换码：')
      if (code) {
        alert('兑换功能待实现')
      }
    }

    // 跳转到登录页面
    const goToLogin = () => {
      router.push('/login')
    }

    // 修改密码（打开修改密码弹窗）
    const openChangePasswordModal = () => {
      showChangePasswordModal.value = true
    }
    
    const closeChangePasswordModal = () => {
      showChangePasswordModal.value = false
    }

    // 退出登录（清除 share-session cookie 并跳转到登录页）
    const openLogoutModal = () => {
      // 清除 share-session cookie（尝试多种路径和域名组合）
      const domain = window.location.hostname
      document.cookie = 'share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      document.cookie = `share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`
      document.cookie = `share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`
      
      // 清除 localStorage 中保存的账号信息
      localStorage.removeItem('savedUsername')
      localStorage.removeItem('savedPassword')
      console.log('🗑️ 已清除所有登录信息')
      
      // 跳转到登录页
      router.push('/login')
    }

    // 获取 share-session cookie 的值
    const getShareSessionCookie = () => {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'share-session') {
          return value
        }
      }
      return ''
    }

    // 打开新PLUS站确认弹窗
    const openNewPlusSiteModal = () => {
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
      // 显示弹窗
      showNewPlusSiteModal.value = true
    }

    // 关闭新PLUS站确认弹窗
    const closeNewPlusSiteModal = () => {
      showNewPlusSiteModal.value = false
    }

    // 检测是否为微信浏览器
    const isWechatBrowser = () => {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger')
    }

    // 确认前往新PLUS站
    const confirmGoToNewPlusSite = async () => {
      closeNewPlusSiteModal()
      
      // 检查是否在 GPT 分类下
      if (currentCategory.value !== 'chatgpt') {
        toast.error('请先切换到 GPT 分类下再点击前往新版PLUS')
        return
      }
      
      // 检查 isPro 权限
      if (!userInfo.isPro) {
        toast.error('无新版PLUS站权限')
        return
      }
      
      // 检查 expireTime 是否为空（始终使用GPT的订阅时间）
      const expireTime = userInfo.expireTime
      if (!expireTime || expireTime === '未知') {
        toast.error('无有效订阅，请及时续费！！！')
        return
      }

      // 在调用 getUserSubscriptions 接口前，检查 GPT 订阅时长是否大于当前时间（上海时区）
      try {
        const expireDate = new Date(expireTime)
        // 获取上海时区（UTC+8）的当前时间
        const nowUTC = new Date()
        const shanghaiTime = new Date(nowUTC.getTime() + (nowUTC.getTimezoneOffset() * 60000) + (8 * 60 * 60000))
        
        console.log('🕐 当前上海时间:', shanghaiTime.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }))
        console.log('📅 GPT订阅到期时间:', expireDate.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }))
        
        // 检查订阅是否已过期
        if (expireDate <= shanghaiTime) {
          toast.error('GPT订阅已过期，请及时续费！！！')
          return
        }
        
        console.log('✅ GPT订阅时长验证通过，剩余时长:', ((expireDate - shanghaiTime) / (1000 * 60 * 60)).toFixed(2), '小时')
      } catch (error) {
        console.error('❌ 时间解析错误:', error)
        toast.error('订阅时间格式错误，请联系管理员')
        return
      }

      // 显示页面加载状态
      isPageLoading.value = true

      // 获取用户订阅信息，判断 subTypeId
      try {
        console.log('📡 开始获取用户订阅信息...')
        const subscriptionRes = await getUserSubscriptions()
        console.log('📋 订阅信息响应:', subscriptionRes)

        if (subscriptionRes.code === 1 && subscriptionRes.data && subscriptionRes.data.list) {
          // 筛选生效中的 GPT 订阅（status === 1 且 subType === 'chatgpt'）
          const activeGptSubscriptions = subscriptionRes.data.list.filter(
            sub => sub.status === 1 && sub.subType === 'chatgpt'
          )
          
          console.log('✅ 生效中的GPT订阅:', activeGptSubscriptions)

          if (activeGptSubscriptions.length > 0) {
            // 取第一个生效中的GPT订阅
            const subscription = activeGptSubscriptions[0]
            const subTypeId = subscription.subTypeId

            console.log('🔍 当前订阅 subTypeId:', subTypeId)

            // 判断 subTypeId
            if (subTypeId === 45) {
              // subTypeId == 45：任何情况都不允许进入
              isPageLoading.value = false
              toast.error('当前订阅套餐不支持访问新版PLUS站点')
              return
            } else if (subTypeId === 49 || subTypeId === 21) {
              // subTypeId == 49 或 21：推荐车队 >= 25 时需要判断时长
              const recommendedCarsCount = allCars.value.filter(car => car.isIQ).length
              console.log('📊 GPT推荐车队数量:', recommendedCarsCount)

              if (recommendedCarsCount >= 25) {
                // 推荐车队 >= 25，需要判断时长 > 25小时
                console.log('⚠️ subTypeId=49/21 且推荐车队>=25，执行时长检查')
                const requiredHours = 25
                const expireDate = new Date(expireTime)
                const nowUTC = new Date()
                const shanghaiTime = new Date(nowUTC.getTime() + (nowUTC.getTimezoneOffset() * 60000) + (8 * 60 * 60000))
                const diffHours = (expireDate - shanghaiTime) / (1000 * 60 * 60)
                
                if (diffHours < requiredHours) {
                  isPageLoading.value = false
                  toast.error(`会员时长大于${requiredHours}小时方可使用新版PLUS`)
                  return
                }
                console.log('✅ 时长检查通过，剩余:', diffHours.toFixed(2), '小时')
              } else {
                // 推荐车队 < 25，直接进入
                console.log('✅ subTypeId=49/21 且推荐车队<25，直接进入')
              }
            } else {
              // subTypeId != 45 && subTypeId != 49：直接进入
              console.log('✅ subTypeId 不是 45 或 49，直接进入')
            }
          } else {
            // 没有生效中的GPT订阅，不允许进入
            console.log('❌ 没有生效中的GPT订阅，拦截')
            isPageLoading.value = false
            toast.error('无生效中的GPT订阅，无法进入新版PLUS')
            return
          }
        } else {
          // 接口调用失败，直接进入
          console.log('✅ 获取订阅信息失败，直接进入')
        }
      } catch (error) {
        console.error('❌ 获取订阅信息异常:', error)
        // 接口异常，直接进入
        console.log('✅ 接口异常，直接进入')
      }

      const shareToken = getShareSessionCookie()
      

      // 快速测试 OAUTH_URL1 和 OAUTH_URL2 是否返回 200 状态码
      let targetUrl = OAUTH_URL
      
      // 测试 OAUTH_URL1
      try {
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 1500)
        
        const testResponse = await fetch(`${OAUTH_URL1}status`, {
          method: 'HEAD',
          mode: 'cors',
          cache: 'no-cache',
          signal: controller.signal
        })
        
        clearTimeout(timeoutId)
        
        if (testResponse.status === 200) {
          targetUrl = OAUTH_URL1
          console.log('✅ OAUTH_URL1 状态检查通过(200)，使用站点1')
        } else {
          throw new Error(`状态码: ${testResponse.status}`)
        }
      } catch (error) {
        console.log('❌ OAUTH_URL1 不可达 (' + (error.name === 'AbortError' ? '超时' : error.message) + ') → 尝试 OAUTH_URL2')
        
        // 测试 OAUTH_URL2
        try {
          const controller2 = new AbortController()
          const timeoutId2 = setTimeout(() => controller2.abort(), 1000)
          
          const testResponse2 = await fetch(`${OAUTH_URL2}status`, {
            method: 'HEAD',
            mode: 'cors',
            cache: 'no-cache',
            signal: controller2.signal
          })
          
          clearTimeout(timeoutId2)
          
          if (testResponse2.status === 200) {
            targetUrl = OAUTH_URL2
            console.log('✅ OAUTH_URL2 状态检查通过(200)，使用站点2')
          } else {
            throw new Error(`状态码: ${testResponse2.status}`)
          }
        } catch (error2) {
          // 两个都不可达，使用备用站点
          console.log('❌ OAUTH_URL2 不可达 (' + (error2.name === 'AbortError' ? '超时' : error2.message) + ') → 使用备用站点')
        }
      }
      
      // 创建隐藏表单，使用 POST 请求提交参数
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = `${targetUrl}loading`
      form.style.display = 'none'
      
      // 添加参数
      const params = {
        sharetoken: shareToken,
        url: targetUrl,
        share_url: window.location.href
      }
      
      for (const [key, value] of Object.entries(params)) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
      }
      
      document.body.appendChild(form)
      form.submit()
    }

    // 处理车对卡片点击
    const handleCarClick = async (carID, carType, isVirtual = false, realCarIDs = null) => {  
      console.log(`🚗 点击车队卡片: ${carID}, 类型: ${carType}, 是否虚拟: ${isVirtual}`)
      
      // 如果是虚拟车队，根据真实车辆数量决定进入方式
      let actualCarID = carID
      if (isVirtual && realCarIDs && realCarIDs.length > 0) {
        if (realCarIDs.length > 3) {
          // 真实车辆大于3个，从前3个(count最小的)中随机选一个
          const randomIndex = Math.floor(Math.random() * 3)
          actualCarID = realCarIDs[randomIndex]
          console.log(`🎭 虚拟车队点击，真实车辆${realCarIDs.length}个>3，从前3随机选中: ${actualCarID}`)
        } else {
          // 真实车辆不超过3个，直接进入第一个(count最小的)
          actualCarID = realCarIDs[0]
          console.log(`🎭 虚拟车队点击，真实车辆${realCarIDs.length}个≤3，直接进入: ${actualCarID}`)
        }
      }
      
      // 检查是否已登录（cookie 存在且未过期）
      if (!hasShareSession() || !isLoggedIn.value) {
        console.log('❌ 未登录或 session 已过期，跳转登录页')
        toast.info('请先登录')
        router.push('/login')
        return
      }

      // 检查 expireTime 是否为空
      const expireTime = carType === 'grok' 
        ? userInfo.grokExpireTime 
        : carType === 'gemini' 
        ? userInfo.geminiExpireTime 
        : userInfo.expireTime
      if (!expireTime || expireTime === '未知') {
        toast.error('无有效订阅，请及时续费！！！')
        return
      }

      try {
        // 显示加载效果
        isJoiningCar.value = true
        console.log('📡 调用 loginSession 接口...')
        
        const res = await loginSession({
          carid: actualCarID,
          carType: carType
        })
        
        console.log('📡 loginSession 响应:', res)

        // 检查成功响应：code = 1 就是接口成功
        if (res.code === 1) {
          // Gemini 车队跳转到 /app，其他车队跳转到根路径
          const targetPath = carType === 'gemini' ? '/app' : '/'
          console.log(`✅ 登录会话成功，跳转到 ${targetPath}`)
          // 跳转前不关闭加载，保持加载状态直到页面跳转完成
          window.location.href = window.location.origin + targetPath
          return
        }

        // 其他情况根据 code 处理
        isJoiningCar.value = false
        console.log('❌ 登录会话失败:', res.msg)
        
        if (res.code === 0) {
          // 特殊情况：其他设备登录，需要跳转到登录页
          if (res.msg && res.msg.includes('其他设备登陆')) {
            toast.error(res.msg)
            router.push('/login')
          } else {
            // 其他 code === 0 的情况只提示错误信息
            toast.error(res.msg || '操作失败')
          }
        } else {
          // 其他情况（如 code === -1）才跳转登录
          toast.error(res.msg || '登录失败')
          router.push('/login')
        }
      } catch (error) {
        // 关闭加载效果
        isJoiningCar.value = false
        console.error('❌ 点击车队卡片失败:', error)
        
        // 处理网络错误或其他异常
        if (error.response && error.response.data) {
          const errorData = error.response.data
          if (errorData.code === -1) {
            toast.error(errorData.msg || '登录失败')
            router.push('/login')
            return
          }
          // code === 0 只提示错误信息
          if (errorData.code === 0) {
            toast.error(errorData.msg || '操作失败')
            return
          }
        }
        
        toast.error('操作失败，请稍后重试')
      }
    }

    // 浏览器后退缓存恢复时重置加载状态
    const handlePageShow = (e) => {
      if (e.persisted) {
        isPageLoading.value = false
        isJoiningCar.value = false
      }
    }

    // 车队列表每分钟自动刷新（静默刷新，不显示加载动画）
    let carRefreshTimer = null
    const startCarRefreshTimer = () => {
      carRefreshTimer = setInterval(() => {
        if (isLoggedIn.value && !iframeMode.value && !showProfile.value && !showMdConvert.value && !showCodex.value) {
          loadCarList()
        }
      }, 60 * 1000)
    }
    const clearCarRefreshTimer = () => {
      if (carRefreshTimer) {
        clearInterval(carRefreshTimer)
        carRefreshTimer = null
      }
    }

    // 初始化
    onMounted(async () => {
      window.addEventListener('pageshow', handlePageShow)

      try {
        console.log('🚀 开始初始化页面...')
        
        // 检测微信浏览器
        if (isWechatBrowser()) {
          console.log('⚠️ 检测到微信浏览器，显示警告')
          showWechatWarning.value = true
        }
        
        // 设置加载状态
        isLoadingCars.value = true

        // 步骤1：检测并获取用户信息（getme）
        if (hasShareSession()) {
          console.log('👤 步骤1: 检测到有效cookie，开始获取用户信息')
          await loadUserInfo()
          console.log('✅ 用户信息加载完成')
        } else {
          console.log('👤 步骤1: 无有效cookie，跳过用户信息获取')
          isLoggedIn.value = false
        }

        // 步骤2：加载配置（getConfig）
        console.log('📋 步骤2: 加载配置信息')
        await loadConfig()
        console.log('✅ 配置加载完成')

        // 步骤3：加载车辆列表（carpage）
        console.log('🚗 步骤3: 加载车辆列表')
        await loadCarList()
        console.log('✅ 车辆列表加载完成')

      } catch (error) {
        console.error('❌ 初始化失败:', error)
      } finally {
        // 所有接口加载完成后关闭加载动画
        console.log('🏁 所有接口加载完成，关闭加载动画')
        isLoadingCars.value = false
        startCarRefreshTimer()
      }
    })

    onBeforeUnmount(() => {
      window.removeEventListener('pageshow', handlePageShow)
      clearCarRefreshTimer()
    })

    return {
      config,
      userInfo,
      currentCategory,
      allCars,
      carNotice,
      searchKeyword,
      displayCategories,
      availableSubCategories,
      filteredDisplayCategories,
      currentSubCategory,
      customMenus,
      recommendedCarsCount,
      requiredHoursForNewPlus,
      iframeMode,
      iframeUrl,
      iframeTitle,
      currentMenuId,
      isLoggedIn,
      showProfile,
      showExchangeModal,
      showChangePasswordModal,
      showNewPlusSiteModal,
      showWechatWarning,
      isLoadingCars,
      isPageLoading,
      isJoiningCar,
      getIconSvg,
      getCategoryIcon,
      getBadgeType,
      getCarStatus,
      getProgressWidth,
      formatCooldown,
      formatExpireTime,
      switchCategory,
      openInIframe,
      closeIframe,
      openProfile,
      closeProfile,
      openExchangeModal,
      closeExchangeModal,
      handleExchange,
      goToLogin,
      openChangePasswordModal,
      closeChangePasswordModal,
      openLogoutModal,
      openNewPlusSiteModal,
      closeNewPlusSiteModal,
      confirmGoToNewPlusSite,
      handleCarClick,
      loadUserInfo,
      noticeHtml,
      noticeIframeRef,
      resizeNoticeIframe,
      headerExpireLabel,
      headerExpireTime,
      
      // MD转换
      showMdConvert,
      openMdConvert,
      selectedFile,
      isDragOver,
      selectedFormats,
      isConverting,
      convertStatus,
      fileInputRef,
      triggerFileInput,
      handleFileSelect,
      handleFileDrop,
      toggleFormat,
      getFormatIcon,
      canConvert,
      convertBtnText,
      startConversion,

      // GPT Codex
      showCodex,
      codexLoading,
      codexData,
      openCodex,
      loadCodexQuota,
      // AI 绘图站
      drawingUrl,
      showDrawingModal,
      goToDrawing,
      closeDrawingModal,
      confirmGoToDrawing
    }
  }
}
</script>

<style>
/* 使用全局样式而不是 scoped，确保所有样式正确应用 */
:root{
  --bg:#fff;--text:#1f1f23;--muted:#7a7a85;--line:#ececf0;--purple:#7b5cff;
  --brand-grad:linear-gradient(141deg, rgba(191,102,255,1) 0%, rgba(98,72,255,1) 50%, rgba(0,221,235,1) 100%);
  --shadow:0 8px 24px rgba(34,27,62,.08);--green:#1acc5a;--notice:#ff4d4f;
  --r-pill:30px;--r-card:20px
}
*{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth;scrollbar-width:none;-ms-overflow-style:none}
html::-webkit-scrollbar{display:none}
body{background:var(--bg);font-family:"Poppins","Microsoft YaHei",sans-serif;color:var(--text);overflow-x:hidden;scrollbar-width:none;-ms-overflow-style:none}
body::-webkit-scrollbar{display:none}
#nav-toggle{display:none}
.page{display:grid;grid-template-columns:200px 1fr;gap:12px;min-height:100vh;padding:12px}

/* 侧边栏 */
.sidebar{display:flex;flex-direction:column;gap:10px;transition:transform .3s ease;z-index:1001;height:calc(100vh - 24px);position:sticky;top:12px}
.side-box{background:#fff;border:2px solid rgba(0,0,0,.05);border-radius:var(--r-card);box-shadow:0 4px 12px rgba(0,0,0,.05);padding:14px}
.side-box:last-child{flex:1;display:flex;flex-direction:column;overflow:hidden}
.side-brand{display:flex;align-items:center;justify-content:center;gap:10px}
.side-brand svg{width:24px;height:24px;fill:currentColor}
.side-brand img{width:24px;height:24px;border-radius:6px;object-fit:cover}
.nav{display:flex;flex-direction:column;gap:12px;flex:1;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}
.nav::-webkit-scrollbar{display:none}
.nav-item{display:flex;align-items:center;justify-content:flex-start;padding:10px 12px;border:2px solid var(--line);border-radius:14px;background:#fff;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);will-change:transform,box-shadow;font-weight:600}
.nav-item:hover{border-color:var(--purple);box-shadow:0 6px 16px rgba(123,92,255,0.2);transform:translateX(4px)}
.nav-item:active{transform:translateX(2px) scale(0.98)}
.nav-item.active{border-color:var(--purple);background:var(--brand-grad);color:#fff;box-shadow:0 4px 12px rgba(123,92,255,0.3)}

/* 主体列 */
.main{display:flex;flex-direction:column;gap:10px}

/* 顶部栏 */
.page-header{display:flex;justify-content:space-between;align-items:center;background:#fff;border:2px solid rgba(0,0,0,.05);border-radius:var(--r-pill);padding:8px 12px;box-shadow:var(--shadow)}
.sys{display:none;align-items:center;gap:10px}
.sys svg{width:22px;height:22px}
.redeem{display:flex;align-items:center;gap:10px;justify-content:flex-end;flex:1}
.action-buttons{display:flex;gap:6px;align-items:center}
.btn-redeem{border:2px dashed var(--notice);color:var(--notice);padding:5px 10px;border-radius:12px;background:#fff;font-weight:700;font-size:14px;white-space:nowrap;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);will-change:transform}
.btn-redeem:hover{background:#fff1f0;border-color:#ff7875;transform:translateY(-2px);box-shadow:0 4px 12px rgba(255,77,79,0.2)}
.btn-redeem:active{transform:translateY(0)}
.btn-plus{border:2px solid var(--purple);color:#fff;background:var(--brand-grad);padding:5px 10px;border-radius:12px;font-weight:700;font-size:14px;white-space:nowrap;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);box-shadow:0 4px 12px rgba(123,92,255,0.3);will-change:transform}
.btn-plus:hover{transform:translateY(-3px);box-shadow:0 8px 20px rgba(123,92,255,0.5)}
.btn-plus:active{transform:translateY(-1px)}
.btn-login{border:2px solid var(--purple);color:#fff;background:var(--brand-grad);padding:6px 20px;border-radius:12px;font-weight:700;font-size:14px;white-space:nowrap;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);box-shadow:0 4px 12px rgba(123,92,255,0.3);will-change:transform}
.btn-login:hover{transform:translateY(-3px);box-shadow:0 8px 20px rgba(123,92,255,0.5)}
.btn-login:active{transform:translateY(-1px)}
.userpill{display:flex;align-items:center;justify-content:center;gap:8px;border:2px solid #ddd;border-radius:12px;padding:5px 8px;white-space:nowrap}
.brand{display:flex;align-items:center;gap:8px}
.brand svg{width:22px;height:22px}

.notice.box{border:2px solid #000;overflow:hidden;padding:0}
.notice-iframe{width:100%;border:none;display:block;height:0;overflow:hidden}
.box{background:#fff;border:2px solid rgba(0,0,0,.05);border-radius:var(--r-card);padding:12px;box-shadow:0 4px 12px rgba(0,0,0,.05)}

.fleet-toolbar{display:flex;justify-content:flex-start;align-items:center;gap:8px;flex-wrap:wrap}
.search{display:flex;align-items:center;gap:6px;border:2px solid var(--line);border-radius:999px;padding:6px 10px;background:#fff;flex:1 1 auto;max-width:372px;min-width:100px}
.search input{border:0;outline:0;font-weight:700;width:100%;min-width:0}

/* 快捷导航 */
.quick-nav{display:flex;gap:6px}
.quick-nav-btn{display:flex;align-items:center;gap:4px;padding:6px 12px;border:2px solid var(--line);border-radius:12px;background:#fff;cursor:pointer;font-weight:700;font-size:14px;color:#666;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);white-space:nowrap;will-change:transform}
.quick-nav-btn:hover{border-color:var(--purple);background:#f6f4ff;color:var(--purple);transform:translateY(-2px);box-shadow:0 4px 12px rgba(123,92,255,0.15)}
.quick-nav-btn:active{transform:translateY(0)}
.quick-nav-btn.active{border-color:var(--purple);background:var(--brand-grad);color:#fff;box-shadow:0 4px 12px rgba(123,92,255,0.3)}
.quick-nav-btn.active svg{fill:#fff}
.quick-nav-btn svg{transition:fill 0.3s}

/* 返回按钮 */
.back-btn{padding:8px 16px;border:2px solid var(--line);border-radius:12px;background:#fff;cursor:pointer;font-weight:700;display:flex;align-items:center;gap:6px;transition:all 0.3s;font-size:14px;color:#333}
.back-btn:hover{border-color:var(--purple);background:#f6f4ff;color:var(--purple);transform:translateX(-2px)}

/* 工具栏分隔线 */
.toolbar-divider {
  width: 2px;
  height: 24px;
  background: var(--line);
  border-radius: 1px;
  flex-shrink: 0;
}

/* 子分类标签（内联在工具栏中） */
.sub-nav-inline {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}
.sub-nav-btn {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border: 2px solid var(--line);
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
  color: #666;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  will-change: transform;
}
.sub-nav-btn:hover {
  border-color: var(--purple);
  background: #f6f4ff;
  color: var(--purple);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(123,92,255,0.15);
}
.sub-nav-btn:active {
  transform: translateY(0);
}
.sub-nav-btn.active {
  border-color: var(--purple);
  background: var(--brand-grad);
  color: #fff;
  box-shadow: 0 4px 12px rgba(123,92,255,0.3);
}

/* 车队分类区域 */
.category-section{margin-bottom:16px}
.category-title{font-size:20px;font-weight:900;color:#1f1f23;margin-bottom:10px;display:flex;align-items:center;gap:8px}

.fleet-content{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:12px}
.botcard{background:#fff;border:3px solid rgba(123,92,255,0.4);border-radius:20px;box-shadow:0 8px 30px rgba(0,0,0,0.2);height:auto;min-height:120px;display:flex;flex-direction:column;backdrop-filter:blur(6px);transition:all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);overflow:hidden;will-change:transform;cursor:pointer}
.botcard:hover{transform:translateY(-8px) scale(1.02);box-shadow:0 16px 48px rgba(123,92,255,0.4);border-color:#7b5cff}
.botcard-hd{background:#fff;padding:12px 14px;display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #ececec;flex-shrink:0;color:#333;font-weight:700}
.botcard-hd > span{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;color:#7b5cff}
.botcard-hd > span svg{display:block;width:100%;height:100%}
.badge-container{display:flex;gap:6px;align-items:center}
.badge{background:linear-gradient(141deg,rgba(191,102,255,1) 0%,rgba(98,72,255,1) 50%,rgba(0,221,235,1) 100%);color:#fff;padding:6px 12px;border-radius:14px;font-size:12px;box-shadow:0 2px 6px rgba(123,92,255,0.4);transition:transform 0.2s ease,box-shadow 0.3s ease;cursor:pointer}
.badge:hover{transform:scale(1.08);box-shadow:0 4px 10px rgba(0,0,0,0.25)}
.recommend-badge{background:linear-gradient(135deg,#ff6b6b,#ff8e53);color:#fff;padding:4px 10px;border-radius:12px;font-size:11px;font-weight:700;box-shadow:0 2px 6px rgba(255,107,107,0.4);animation:pulse-glow 2s ease-in-out infinite}
.botcard-bd{padding:14px 16px;display:flex;justify-content:space-between;flex:1;align-items:center;font-size:14px;font-weight:900;color:#222;letter-spacing:0.3px}
.botcard-bd > div:first-child{font-size:17px;font-weight:900}
.botcard-bd > div:last-child{color:#555;font-size:14px;font-weight:700}
.model-pills{display:inline-flex;gap:8px;align-items:center;flex-shrink:0}
.model-dot-pill{width:11px;height:11px;border-radius:50%;display:inline-block;cursor:help;transition:transform .15s ease,box-shadow .2s ease;border:2px solid #fff}
.model-dot-pill:hover{transform:scale(1.25)}
.model-dot-pill.ok{background:#10b981;box-shadow:0 0 0 2px rgba(16,185,129,.25),0 1px 3px rgba(0,0,0,.15)}
.model-dot-pill.busy{background:#ef4444;box-shadow:0 0 0 2px rgba(239,68,68,.25),0 1px 3px rgba(0,0,0,.15)}
.prog{height:9px;background:#f3f3f3;margin:0 14px 12px;border-radius:999px;flex-shrink:0;overflow:hidden}
.prog div{height:100%;width:30%;background:linear-gradient(90deg,#7b5cff,#3aa0ff);border-radius:999px;box-shadow:0 0 10px rgba(123,92,255,0.5);transition:width 0.8s cubic-bezier(0.4, 0, 0.2, 1)}

/* 移动端 */
.hamburger{display:none}
.drawer-mask{display:none}
.close-btn{display:none}

/* 中等屏幕适配 (1000px以下) */
@media(max-width:1000px){
  .page-header{flex-wrap:wrap;gap:8px}
  .redeem{flex-direction:column;align-items:stretch;gap:8px;width:100%}
  .action-buttons{flex-direction:row;justify-content:center;gap:6px;width:100%}
  .btn-redeem,.btn-plus{flex:1;white-space:nowrap;min-width:0}
  .userpill{flex-wrap:wrap;justify-content:center;width:100%}
  .userpill > div:first-child{flex:0 0 100%;text-align:center;margin-bottom:4px}
  .userpill small{flex:0 0 100%;text-align:center;margin-left:0}
}

@media(max-width:768px){
  .page{grid-template-columns:1fr;position:relative;overflow:hidden;padding:8px}
  .hamburger{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border:2px solid var(--line);border-radius:10px;background:#fff;cursor:pointer;font-size:20px;line-height:1}
  
  .sys{display:flex;justify-content:space-between;align-items:center;order:1}
  .brand{display:flex;justify-content:center;flex:1}
  .hamburger{margin-right:auto}
  
  .page-header{flex-direction:column;gap:8px}
  .redeem{width:100%;justify-content:space-between;flex-wrap:wrap}
  
  .fleet-toolbar{gap:6px;flex-wrap:wrap;align-items:flex-start}
  .search{flex:1 0 100%;min-width:80px;max-width:none;order:3}
  .quick-nav{gap:4px;flex-shrink:0;align-self:center}
  .quick-nav-btn{padding:5px 10px;font-size:13px;gap:3px;flex-shrink:0}
  .quick-nav-btn svg{width:16px;height:16px}
  
  .fleet-content{gap:10px;grid-template-columns:repeat(auto-fill,minmax(160px,1fr))}
  .category-title{font-size:18px}
  .toolbar-divider{width:2px;height:24px;align-self:center}
  .sub-nav-inline{gap:4px;flex:1 1 0;min-width:0;overflow:visible;flex-wrap:wrap}
  .sub-nav-btn{padding:5px 12px;font-size:12px;flex-shrink:0}
  
  .sidebar{
    position:fixed;
    left:0;
    top:0;
    width:100vw;
    height:auto;
    max-height:80vh;
    background:#fff;
    border-bottom-left-radius:20px;
    border-bottom-right-radius:20px;
    box-shadow:0 12px 40px rgba(0,0,0,0.25);
    padding:18px 14px;
    z-index:1001;
    transform:translateY(-100%);
    pointer-events:none;
    transition:transform 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow-y:auto;
    scrollbar-width:none;
    -ms-overflow-style:none;
    display:flex;
    flex-direction:column;
    gap:18px;
  }
  
  .sidebar::-webkit-scrollbar{
    display:none;
  }
  
  #nav-toggle:checked ~ .page .sidebar{
    transform:translateY(0);
    pointer-events:auto;
  }
  
  .drawer-mask{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,0.5);
    backdrop-filter:blur(4px);
    z-index:1000;
    opacity:0;
    pointer-events:none;
    transition:opacity 0.3s ease;
  }
  
  #nav-toggle:checked ~ .page .drawer-mask{
    display:block;
    opacity:1;
    pointer-events:auto;
  }
  
  .close-btn{
    display:block;
    position:absolute;
    top:16px;
    right:16px;
    width:32px;
    height:32px;
    border:none;
    border-radius:50%;
    background:#f5f5f5;
    cursor:pointer;
    font-size:20px;
    line-height:1;
    font-weight:300;
    color:#666;
    z-index:10;
    display:grid;
    place-items:center;
  }
  
  .side-box{
    border:none;
    box-shadow:none;
    background:transparent;
    padding:0;
    margin:0;
  }
  
  .side-box:first-of-type{
    background:transparent;
    padding:0;
    margin-bottom:0;
    border-bottom:none;
  }
  
  .side-box:last-of-type{
    background:transparent;
    padding:0;
    flex:none;
  }
  
  .side-brand{
    margin-top:0;
    justify-content:flex-start;
    padding-bottom:14px;
    border-bottom:1px solid #f0f0f0;
  }
  
  .nav-item{
    background:#f8f9fa;
    border:1px solid #e9ecef;
    border-radius:12px;
    padding:12px 14px;
    justify-content:flex-start;
    transition:all 0.2s ease;
  }
  
  .nav-item:active{
    background:#e9ecef;
    transform:scale(0.98);
  }
  
  .nav-item.active{
    border-color:var(--purple);
    background:var(--brand-grad);
    color:#fff;
  }
  
  .nav-item.active .nav-ico{
    background:rgba(255,255,255,0.2);
  }
  
  .nav-item.active .nav-ico svg{
    fill:#fff;
  }

  .page-header{flex-direction:column;align-items:stretch;gap:8px;padding:10px;border-radius:16px}
  .sys{display:flex;justify-content:space-between;align-items:center;order:1}
  .brand{display:flex;justify-content:center;flex:1}
  .hamburger{margin-right:auto}
  .redeem{flex-direction:column;order:2;gap:6px;justify-content:center}
  .action-buttons{width:100%;display:flex;flex-direction:column;gap:6px}
  .userpill{width:100%;justify-content:center;padding:8px 10px;gap:6px;flex-wrap:wrap;display:flex}
  .userpill > div:first-child{font-weight:700;flex:0 0 100%;text-align:center}
  .userpill small{flex:0 0 100%;text-align:center;font-size:11px;color:var(--muted);margin-left:0}
  .btn-redeem{width:100%;text-align:center;padding:8px 10px;font-size:13px}
  .btn-plus{width:100%;text-align:center;padding:8px 10px;font-size:13px}
  .btn-login{width:100%;text-align:center;padding:10px;font-size:14px}

  .notice.box{font-size:13px;padding:10px;line-height:1.5}
  .fleet-toolbar{flex-direction:row;align-items:flex-start;gap:6px;flex-wrap:wrap}
  .search{flex:1 0 100%;min-width:80px;max-width:none;order:3}
  .search input{font-size:14px;min-width:0}

  .fleet-content{grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:10px}
  .botcard{min-height:120px}
  .botcard-hd{padding:10px 12px;font-size:14px}
  .botcard-hd > span{width:26px;height:26px}
  .badge-container{gap:4px;flex-wrap:wrap}
  .badge{padding:4px 10px;font-size:11px}
  .recommend-badge{padding:3px 8px;font-size:10px}
  .botcard-bd{font-size:13px;padding:10px 12px}
  .botcard-bd > div:first-child{font-size:16px}
  .botcard-bd > div:last-child{font-size:13px}
  .model-pills{gap:6px}
  .model-dot-pill{width:10px;height:10px}
  .prog{margin:0 12px 10px;height:8px}
}

.main{min-width:0}

@media (min-width: 769px) {
  .drawer-mask { display: none !important; pointer-events: none !important; opacity: 0 !important; }
  .close-btn { display: none !important; }
}

@supports not (display: grid) {
  .page { display: flex; gap: 20px; }
  .sidebar { width: 220px; flex: 0 0 220px; }
  .main { flex: 1 1 auto; min-width: 0; }
}

/* 新PLUS站确认弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;
}

.modal-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-content {
  margin-bottom: 24px;
}

.confirm-content {
  text-align: center;
  padding: 20px 0;
}

.confirm-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.confirm-message {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}

.confirm-submessage {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.confirm-hint {
  font-size: 14px;
  color: #666;
  margin: 16px 0 0 0;
  line-height: 1.8;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%);
  border-radius: 10px;
  border: 1px solid #ffc107;
}

.confirm-hint strong {
  color: #ff6b35;
  font-weight: 700;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.tech-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 90px;
}

.tech-btn.secondary {
  background: #fff;
  color: #666;
  border: 1px solid #d9d9d9;
}

.tech-btn.secondary:hover {
  color: #333;
  border-color: #333;
  background: #f5f5f5;
}

.tech-btn.primary {
  background: linear-gradient(135deg, #7b5cff, #9b7bff);
  color: white;
  box-shadow: 0 4px 12px rgba(123, 92, 255, 0.3);
}

.tech-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(123, 92, 255, 0.4);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 加载动画 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  min-height: 400px;
}

.loading-spinner-large {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(123, 92, 255, 0.1);
  border-radius: 50%;
  border-top-color: #7b5cff;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-text {
  font-size: 16px;
  color: #666;
  font-weight: 600;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes pulse-glow {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 2px 6px rgba(255,107,107,0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(255,107,107,0.6);
  }
}

/* iframe 容器样式 */
.iframe-fullheight {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

@media(max-width:768px){
  .iframe-fullheight {
    height: calc(100vh - 120px);
  }
}

/* 全局页面加载 */
.page-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.page-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.page-loading-spinner {
  width: 80px;
  height: 80px;
  border: 6px solid rgba(123, 92, 255, 0.2);
  border-radius: 50%;
  border-top-color: #7b5cff;
  animation: spin 1s linear infinite;
}

.page-loading-text {
  font-size: 18px;
  color: #666;
  font-weight: 600;
  letter-spacing: 1px;
  animation: pulse 1.5s ease-in-out infinite;
}

/* 微信浏览器强制拦截弹窗 */
.wechat-warning-overlay {
  z-index: 10000;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
}

.wechat-warning-modal {
  border: 4px solid #ff4d4f;
  box-shadow: 0 20px 80px rgba(255, 77, 79, 0.6);
  background: linear-gradient(135deg, #fff 0%, #fff5f5 100%);
  max-width: 500px;
}

.wechat-warning-modal .modal-content {
  padding: 20px 0;
}

.wechat-warning-modal .confirm-icon {
  font-size: 100px;
  animation: pulse-scale 2s ease-in-out infinite;
  filter: drop-shadow(0 4px 12px rgba(255, 77, 79, 0.3));
}

.wechat-warning-modal .confirm-message {
  font-size: 28px;
  color: #ff4d4f;
  font-weight: 900;
  margin: 20px 0 12px 0;
  text-shadow: 0 2px 4px rgba(255, 77, 79, 0.2);
}

.wechat-warning-modal .confirm-submessage {
  font-size: 16px;
  color: #333;
  margin: 12px 0;
  line-height: 1.6;
  font-weight: 600;
}

.wechat-guide {
  margin-top: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #fff9e6 0%, #ffe6e6 100%);
  border-radius: 12px;
  border: 2px dashed #ff8e53;
  text-align: left;
}

.guide-step {
  font-size: 15px;
  color: #333;
  margin: 8px 0;
  font-weight: 600;
  line-height: 1.8;
}

.guide-step:first-child {
  font-size: 17px;
  color: #ff6b6b;
  font-weight: 700;
  margin-bottom: 12px;
}

@keyframes pulse-scale {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@media(max-width:768px){
  .wechat-warning-modal {
    margin: 0 20px;
  }
  
  .wechat-warning-modal .confirm-icon {
    font-size: 80px;
  }
  
  .wechat-warning-modal .confirm-message {
    font-size: 24px;
  }
  
  .wechat-warning-modal .confirm-submessage {
    font-size: 15px;
  }
  
  .guide-step {
    font-size: 14px;
  }
  
  .guide-step:first-child {
    font-size: 16px;
  }
}

/* MD转换样式 */
.md-convert-container {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.convert-card {
  width: 100%;
  max-width: 600px;
  padding: 32px;
  text-align: center;
}
.convert-title {
  font-size: 22px;
  font-weight: 800;
  color: #1f1f23;
  margin-bottom: 8px;
}
.convert-sub {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}
.drop-zone {
  border: 2px dashed #e0e0e0;
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 24px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fcfcfc;
}
.drop-zone:hover, .drop-zone.drag-over {
  border-color: var(--purple);
  background: #f6f4ff;
}
.drop-zone.has-file {
  border-color: #1acc5a;
  background: #f0fdf4;
}
.drop-content .icon { font-size: 40px; margin-bottom: 12px; }
.drop-content .filename { font-weight: 700; color: #333; font-size: 16px; word-break: break-all; }
.drop-content .text { font-size: 14px; color: #666; }
.drop-content .text-sm { font-size: 12px; color: #999; margin-top: 6px; }

.format-group {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 24px;
}
.format-btn {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px 0;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.format-btn:hover {
  border-color: var(--purple);
  color: var(--purple);
  background: #f6f4ff;
}
.format-btn.active {
  border-color: transparent;
  background: var(--brand-grad);
  color: #fff;
  box-shadow: 0 4px 12px rgba(123,92,255,0.3);
}
.format-btn .ext { font-size: 20px; }
.format-btn .label { font-size: 12px; font-weight: 700; }

.convert-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: var(--brand-grad);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(123,92,255,0.3);
}
.convert-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}
.convert-btn:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(123,92,255,0.4);
}

.status-msg {
  margin-top: 16px;
  padding: 12px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}
.status-msg.loading { background: #e6f7ff; color: #1890ff; }
.status-msg.success { background: #f6ffed; color: #52c41a; }
.status-msg.error { background: #fff1f0; color: #f5222d; }

.convert-info {
  margin-top: 24px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 8px;
  font-size: 12px;
  color: #888;
  line-height: 1.6;
}
.spinner-sm {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-right: 6px;
}
</style>

